import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../../Components/Footer';

function DraggableCards() {
    const [isToggled, setIsToggled] = useState(false);


    // Toggle sidebar and update localStorage
    const toggleSidebar = () => {
        const newState = !isToggled;
        setIsToggled(newState);
        localStorage.setItem("isToggled", newState);
    };


    useEffect(() => {
        // Optionally log the state to verify persistence
        console.log("Sidebar state:", isToggled);
    }, [isToggled]);

    const [isOpenCharts, setIsOpenCharts] = useState(false);

    const toggleMenuCharts = () => {
        setIsOpenCharts(!isOpenCharts);
    };


    const [isOpenApps, setIsOpenApps] = useState(false);
    const toggleMenuApps = () => {
        setIsOpenApps(!isOpenApps);
    };

    const [isOpenElements, setIsOpenElements] = useState(false);
    const toggleMenuElements = () => {
        setIsOpenElements(!isOpenElements);
    };
    const [isOpenMenu, setIsOpenMenu] = useState(false);
    const toggleMenuMenu = () => {
        setIsOpenMenu(!isOpenMenu);
    };

    const [isOpenAdvanced, setIsOpenAdvanced] = useState(false);
    const toggleMenuAdvanced = () => {
        setIsOpenAdvanced(!isOpenAdvanced);
    };

    const [isOpenForms, setIsOpenForms] = useState(false);
    const toggleMenuForms = () => {
        setIsOpenForms(!isOpenForms);
    };

    const [isOpenTables, setIsOpenTables] = useState(false);
    const toggleOpenTables = () => {
        setIsOpenTables(!isOpenTables);
    };

    const [isOpenMaps, setIsOpenMaps] = useState(false);
    const toggleMenuMaps = () => {
        setIsOpenMaps(!isOpenMaps);
    };
    const [isOpenPages, setIsOpenPages] = useState(false);
    const toggleMenuPages = () => {
        setIsOpenPages(!isOpenPages);
    };
    const [isOpenUtilities, setOpenUtilities] = useState(false)
    const toggleMenuUtilities = () => {
        setOpenUtilities(!isOpenUtilities)
    }
    const [isOpenApexCharts, setOpenApexCharts] = useState(false)
    const toggleMenuApexCharts = () => {
        setOpenApexCharts(!isOpenApexCharts)
    }

    const [isOpenBlogPages, setOpenBlogPages] = useState(false)
    const toggleMenuBlogPages = () => {
        setOpenBlogPages(!isOpenBlogPages)
    }
    const [isOpenLevel2, setOpenLevel2] = useState(false)
    const toggleMenuLevel2 = () => {
        setOpenLevel2(!isOpenLevel2)
    }

    const [isOpenLevel22, setOpenLevel22] = useState(false)
    const toggleMenuLevel22 = () => {
        setOpenLevel22(!isOpenLevel22)
    }
    const [isFileManager, setFileManager] = useState(false)
    const toggleFileManager = () => {
        setFileManager(!isFileManager)
    }
    const [isFormElements, setFormElements] = useState(false)
    const toggleFormElements = () => {
        setFormElements(!isFormElements)
    }
    const [isFormEditors, setFormEditors] = useState(false)
    const toggleFormEditors = () => {
        setFormEditors(!isFormEditors)
    }
    const [isMail, setMail] = useState(false)
    const toggleMail = () => {
        setMail(!isMail)
    }
    const [isEcommerce, setEcommerce] = useState(false)
    const toggleEcommerce = () => {
        setEcommerce(!isEcommerce)
    }
    const [isCustomPages, setCustomPages] = useState(false)
    const toggleCustomPages = () => {
        setCustomPages(!isCustomPages)
    }



    return (
        <>
            <div className="" dir="ltr"
                data-nav-layout="vertical"
                loader="disable" data-vertical-style={isToggled ? "overlay" : "hidden"}
                data-toggled={isToggled ? "icon-overlay-close" : "icon-overlay-open"} >
                {/* app-header */}
                <header className="app-header" >
                    {/* Start::main-header-container */}
                    <div className="main-header-container container-fluid">
                        {/* Start::header-content-left */}
                        <div className="header-content-left">
                            {/* Start::header-element */}
                            <div className="header-element">
                                <div className="horizontal-logo">
                                    <Link to="/" className="header-logo">
                                        <img
                                            src="assets/images/brand-logos/desktop-logo.png"
                                            alt="logo"
                                            className="desktop-logo"
                                        />
                                        <img
                                            src="assets/images/brand-logos/toggle-logo.png"
                                            alt="logo"
                                            className="toggle-logo"
                                        />
                                        <img
                                            src="assets/images/brand-logos/desktop-white.png"
                                            alt="logo"
                                            className="desktop-white"
                                        />
                                        <img
                                            src="assets/images/brand-logos/toggle-white.png"
                                            alt="logo"
                                            className="toggle-white"
                                        />
                                    </Link>
                                </div>
                            </div>
                            {/* End::header-element */}
                            {/* Start::header-element */}
                            <div className="header-element">
                                {/* Start::header-link */}
                                <Link
                                    aria-label="Hide Sidebar"
                                    className="sidemenu-toggle header-link animated-arrow hor-toggle horizontal-navtoggle"
                                    data-bs-toggle="sidebar"
                                    to="#"
                                    onClick={toggleSidebar}

                                >
                                    <i className="header-icon fe fe-align-left"
                                    />
                                </Link>
                                <div className="main-header-center d-none d-lg-block">
                                    <input
                                        className="form-control"
                                        placeholder="Search for anything..."
                                        type="search"
                                    />{" "}
                                    <button className="btn">
                                        <i className="fa fa-search d-none d-md-block" />
                                    </button>
                                </div>
                                {/* End::header-link */}
                            </div>
                            {/* End::header-element */}
                        </div>
                        {/* End::header-content-left */}
                        {/* Start::header-content-right */}
                        <div className="header-content-right">
                            <div className="header-element Search-element d-block d-lg-none">
                                {/* Start::header-link|dropdown-toggle */}
                                <Link
                                    to="#"
                                    className="header-link dropdown-toggle"
                                    data-bs-auto-close="outside"
                                    data-bs-toggle="dropdown"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 -960 960 960"
                                        className="header-link-icon"
                                    >
                                        <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" />
                                    </svg>
                                </Link>
                                {/* End::header-link|dropdown-toggle */}
                                <ul
                                    className="main-header-dropdown dropdown-menu dropdown-menu-end Search-element-dropdown"
                                    data-popper-placement="none"
                                >
                                    <li>
                                        <div className="input-group w-100 p-2">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search...."
                                            />
                                            <div className="btn btn-primary">
                                                <i className="fa fa-search" aria-hidden="true" />
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            {/* Start::header-element */}
                            <div className="header-element country-selector">
                                {/* Start::header-link|dropdown-toggle */}
                                <Link
                                    to="#"
                                    className="header-link dropdown-toggle"
                                    data-bs-auto-close="outside"
                                    data-bs-toggle="dropdown"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        className="flag-icon1"
                                    >
                                        {" "}
                                        <circle cx={256} cy={256} r={256} fill="#f0f0f0" />{" "}
                                        <g fill="#0052b4">
                                            {" "}
                                            <path d="M52.92 100.142c-20.109 26.163-35.272 56.318-44.101 89.077h133.178L52.92 100.142zM503.181 189.219c-8.829-32.758-23.993-62.913-44.101-89.076l-89.075 89.076h133.176zM8.819 322.784c8.83 32.758 23.993 62.913 44.101 89.075l89.074-89.075H8.819zM411.858 52.921c-26.163-20.109-56.317-35.272-89.076-44.102v133.177l89.076-89.075zM100.142 459.079c26.163 20.109 56.318 35.272 89.076 44.102V370.005l-89.076 89.074zM189.217 8.819c-32.758 8.83-62.913 23.993-89.075 44.101l89.075 89.075V8.819zM322.783 503.181c32.758-8.83 62.913-23.993 89.075-44.101l-89.075-89.075v133.176zM370.005 322.784l89.075 89.076c20.108-26.162 35.272-56.318 44.101-89.076H370.005z" />{" "}
                                        </g>{" "}
                                        <g fill="#d80027">
                                            {" "}
                                            <path d="M509.833 222.609H289.392V2.167A258.556 258.556 0 00256 0c-11.319 0-22.461.744-33.391 2.167v220.441H2.167A258.556 258.556 0 000 256c0 11.319.744 22.461 2.167 33.391h220.441v220.442a258.35 258.35 0 0066.783 0V289.392h220.442A258.533 258.533 0 00512 256c0-11.317-.744-22.461-2.167-33.391z" />{" "}
                                            <path d="M322.783 322.784L437.019 437.02a256.636 256.636 0 0015.048-16.435l-97.802-97.802h-31.482v.001zM189.217 322.784h-.002L74.98 437.019a256.636 256.636 0 0016.435 15.048l97.802-97.804v-31.479zM189.217 189.219v-.002L74.981 74.98a256.636 256.636 0 00-15.048 16.435l97.803 97.803h31.481zM322.783 189.219L437.02 74.981a256.328 256.328 0 00-16.435-15.047l-97.802 97.803v31.482z" />{" "}
                                        </g>{" "}
                                    </svg>
                                </Link>
                                {/* End::header-link|dropdown-toggle */}
                                <ul
                                    className="main-header-dropdown dropdown-menu dropdown-menu-end country-dropdown"
                                    data-popper-placement="none"
                                >
                                    <li>
                                        <Link
                                            className="dropdown-item d-flex align-items-center"
                                            to="#"
                                        >
                                            <span>
                                                <img
                                                    src="assets/images/flags/french_flag.jpg"
                                                    alt="img"
                                                    className="avatar avatar-xs lh-1 me-2"
                                                />
                                            </span>
                                            French
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            className="dropdown-item d-flex align-items-center"
                                            to="#"
                                        >
                                            <span>
                                                <img
                                                    src="assets/images/flags/germany_flag.jpg"
                                                    alt="img"
                                                    className="avatar avatar-xs lh-1 me-2"
                                                />
                                            </span>
                                            German
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            className="dropdown-item d-flex align-items-center"
                                            to="#"
                                        >
                                            <span>
                                                <img
                                                    src="assets/images/flags/italy_flag.jpg"
                                                    alt="img"
                                                    className="avatar avatar-xs lh-1 me-2"
                                                />
                                            </span>
                                            Italian
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            className="dropdown-item d-flex align-items-center"
                                            to="#"
                                        >
                                            <span>
                                                <img
                                                    src="assets/images/flags/russia_flag.jpg"
                                                    alt="img"
                                                    className="avatar avatar-xs lh-1 me-2"
                                                />
                                            </span>
                                            Russian
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            className="dropdown-item d-flex align-items-center"
                                            to="#"
                                        >
                                            <span>
                                                <img
                                                    src="assets/images/flags/spain_flag.jpg"
                                                    alt="img"
                                                    className="avatar avatar-xs lh-1 me-2"
                                                />
                                            </span>
                                            Spanish
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            {/* End::header-element */}
                            {/* Start::header-element */}

                            {/* End::header-element */}
                            {/* Start::header-element */}
                            <div className="header-element messages-dropdown">
                                {/* Start::header-link|dropdown-toggle */}
                                <Link
                                    to="#"
                                    className="header-link dropdown-toggle"
                                    data-bs-auto-close="outside"
                                    data-bs-toggle="dropdown"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="header-link-icon"
                                        height="24px"
                                        viewBox="0 0 24 24"
                                        width="24px"
                                        fill="currentColor"
                                    >
                                        <path d="M0 0h24v24H0V0z" fill="none" />
                                        <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z" />
                                    </svg>
                                    <span className="pulse-danger" />
                                </Link>
                                {/* End::header-link|dropdown-toggle */}
                                {/* Start::main-header-dropdown */}
                                <div
                                    className="main-header-dropdown dropdown-menu dropdown-menu-end main-header-message"
                                    data-popper-placement="none"
                                >
                                    <div className="menu-header-content bg-primary text-fixed-white">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h6 className="mb-0 fs-15 fw-semibold text-fixed-white">
                                                Messages
                                            </h6>
                                            <span className="badge rounded-pill bg-warning pt-1 text-fixed-black">
                                                Mark All Read
                                            </span>
                                        </div>
                                        <p className="dropdown-title-text subtext mb-0 text-fixed-white op-6 pb-0 fs-12 ">
                                            You have 4 unread messages
                                        </p>
                                    </div>
                                    <div>
                                        <hr className="dropdown-divider" />
                                    </div>
                                    <ul className="list-unstyled mb-0" id="header-cart-items-scroll">
                                        <li className="dropdown-item">
                                            <div className="d-flex messages">
                                                <span className="avatar avatar-md me-2 online avatar-rounded flex-shrink-0">
                                                    <img src="assets/images/faces/12.jpg" alt="img" />
                                                </span>
                                                <div>
                                                    <div className="d-flex">
                                                        <Link to="/Chat">
                                                            <h6 className="mb-1 name">Petey Cruiser</h6>
                                                        </Link>
                                                    </div>
                                                    <p className="mb-0 fs-12 desc">
                                                        I'm sorry but i'm not sure how to help you with
                                                        that......
                                                    </p>
                                                    <p className="time mb-0 text-start float-start ms-2 mt-2">
                                                        Mar 15 3:55 PM
                                                    </p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="dropdown-item">
                                            <div className="d-flex messages">
                                                <span className="avatar avatar-md me-2 online avatar-rounded flex-shrink-0">
                                                    <img src="assets/images/faces/3.jpg" alt="img" />
                                                </span>
                                                <div>
                                                    <div className="d-flex">
                                                        <Link to="/Chat">
                                                            <h6 className="mb-1 name">Jimmy Changa</h6>
                                                        </Link>
                                                    </div>
                                                    <p className="mb-0 fs-12 desc">
                                                        All set ! Now, time to get to you now......
                                                    </p>
                                                    <p className="time mb-0 text-start float-start ms-2 mt-2">
                                                        Mar 06 01:12 AM
                                                    </p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="dropdown-item">
                                            <div className="d-flex messages">
                                                <span className="avatar avatar-md me-2 online avatar-rounded flex-shrink-0">
                                                    <img src="assets/images/faces/5.jpg" alt="img" />
                                                </span>
                                                <div>
                                                    <div className="d-flex">
                                                        <Link to="/Chat">
                                                            <h6 className="mb-1 name">Graham Cracker</h6>
                                                        </Link>
                                                    </div>
                                                    <p className="mb-0 fs-12 desc">
                                                        Are you ready to pickup your Delivery...
                                                    </p>
                                                    <p className="time mb-0 text-start float-start ms-2 mt-2">
                                                        Feb 25 10:35 AM
                                                    </p>
                                                </div>
                                            </div>
                                        </li>

                                    </ul>
                                    <div className="text-center dropdown-footer">
                                        <Link to="/Chat" className="text-primary fs-13">
                                            VIEW ALL
                                        </Link>
                                    </div>
                                </div>
                                {/* End::main-header-dropdown */}
                            </div>
                            {/* End::header-element */}
                            {/* Start::header-element */}
                            <div className="header-element notifications-dropdown main-header-notification">
                                {/* Start::header-link|dropdown-toggle */}
                                <Link
                                    to="#"
                                    className="header-link dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    data-bs-auto-close="outside"
                                    id="messageDropdown"
                                    aria-expanded="false"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="header-link-icon"
                                        height="24px"
                                        viewBox="0 0 24 24"
                                        width="24px"
                                        fill="currentColor"
                                    >
                                        <path d="M0 0h24v24H0V0z" fill="none" />
                                        <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" />
                                    </svg>
                                    <span className="pulse-success" />
                                </Link>
                                {/* End::header-link|dropdown-toggle */}
                                {/* Start::main-header-dropdown */}
                                <div
                                    className="main-header-dropdown dropdown-menu dropdown-menu-end main-header-message"
                                    data-popper-placement="none"
                                >
                                    <div className="menu-header-content bg-primary text-fixed-white">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h6 className="mb-0 fs-15 fw-semibold text-fixed-white">
                                                Notifications
                                            </h6>
                                            <span className="badge rounded-pill bg-warning pt-1 text-fixed-black">
                                                Mark All Read
                                            </span>
                                        </div>
                                        <p className="dropdown-title-text subtext mb-0 text-fixed-white op-6 pb-0 fs-12 ">
                                            You have 4 unread Notifications
                                        </p>
                                    </div>
                                    <div>
                                        <hr className="dropdown-divider" />
                                    </div>
                                    <ul
                                        className="list-unstyled mb-0"
                                        id="header-notification-scroll"
                                    >
                                        <li className="dropdown-item px-3">
                                            <div className="d-flex">
                                                <span className="avatar avatar-md me-2 avatar-rounded flex-shrink-0 bg-pink">
                                                    <i className="la la-file-alt fs-20" />
                                                </span>
                                                <div className="ms-3">
                                                    <Link to="/Mail">
                                                        <h5 className="notification-label text-dark mb-1">
                                                            New files available
                                                        </h5>
                                                    </Link>
                                                    <div className="notification-subtext">10 hour ago</div>
                                                </div>
                                                <div className="ms-auto">
                                                    <Link to="/Mail">
                                                        <i className="las la-angle-right text-end text-muted icon" />
                                                    </Link>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="dropdown-item px-3">
                                            <div className="d-flex">
                                                <span className="avatar avatar-md me-2 avatar-rounded flex-shrink-0 bg-purple">
                                                    <i className="la la-gem fs-20" />
                                                </span>
                                                <div className="ms-3">
                                                    <Link to="/Mail">
                                                        <h5 className="notification-label text-dark mb-1">
                                                            Updates Available
                                                        </h5>
                                                    </Link>
                                                    <div className="notification-subtext">2 days ago</div>
                                                </div>
                                                <div className="ms-auto">
                                                    <Link to="/Mail">
                                                        <i className="las la-angle-right text-end text-muted icon" />
                                                    </Link>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="dropdown-item px-3">
                                            <div className="d-flex">
                                                <span className="avatar avatar-md me-2 avatar-rounded flex-shrink-0 bg-success">
                                                    <i className="la la-shopping-basket fs-20" />
                                                </span>
                                                <div className="ms-3">
                                                    <Link to="/Mail">
                                                        <h5 className="notification-label text-dark mb-1">
                                                            New Order Received
                                                        </h5>
                                                    </Link>
                                                    <div className="notification-subtext">1 hour ago</div>
                                                </div>
                                                <div className="ms-auto">
                                                    <Link to="/Mail">
                                                        <i className="las la-angle-right text-end text-muted icon" />
                                                    </Link>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="dropdown-item px-3">
                                            <div className="d-flex">
                                                <span className="avatar avatar-md me-2 avatar-rounded flex-shrink-0 bg-warning">
                                                    <i className="la la-envelope-open fs-20 text-fixed-white" />
                                                </span>
                                                <div className="ms-3">
                                                    <Link to="/Mail">
                                                        <h5 className="notification-label text-dark mb-1">
                                                            New review received
                                                        </h5>
                                                    </Link>
                                                    <div className="notification-subtext">1 day ago</div>
                                                </div>
                                                <div className="ms-auto">
                                                    <Link to="/Mail">
                                                        <i className="las la-angle-right text-end text-muted icon" />
                                                    </Link>
                                                </div>
                                            </div>
                                        </li>

                                    </ul>
                                    <div className="text-center dropdown-footer">
                                        <Link to="/Mail" className="text-primary fs-13">
                                            VIEW ALL
                                        </Link>
                                    </div>
                                </div>
                                {/* End::main-header-dropdown */}
                            </div>
                            {/* End::header-element */}
                            {/* Start::header-element */}
                            <div className="header-element headerProfile-dropdown">
                                {/* Start::header-link|dropdown-toggle */}
                                <Link
                                    to="#"
                                    className="header-link dropdown-toggle"
                                    id="mainHeaderProfile"
                                    data-bs-toggle="dropdown"
                                    data-bs-auto-close="outside"
                                    aria-expanded="false"
                                >
                                    <img
                                        src="assets/images/faces/6.jpg"
                                        alt="img"
                                        width={37}
                                        height={37}
                                        className="rounded-circle"
                                    />
                                </Link>
                                {/* End::header-link|dropdown-toggle */}
                                <ul
                                    className="main-header-dropdown dropdown-menu pt-0 header-profile-dropdown dropdown-menu-end main-profile-menu"
                                    aria-labelledby="mainHeaderProfile"
                                >
                                    <li>
                                        <div className="main-header-profile bg-primary menu-header-content text-fixed-white">
                                            <div className="my-auto">
                                                <h6 className="mb-0 lh-1 text-fixed-white">
                                                    Petey Cruiser
                                                </h6>
                                                <span className="fs-11 op-7 lh-1">Premium Member</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item d-flex" to="/Profile">
                                            <i className="bx bx-user-circle fs-18 me-2 op-7" />
                                            Profile
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item d-flex" to="/Editprofile">
                                            <i className="bx bx-cog fs-18 me-2 op-7" />
                                            Edit Profile{" "}
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            className="dropdown-item d-flex border-block-end"
                                            to="/Mail"
                                        >
                                            <i className="bx bxs-inbox fs-18 me-2 op-7" />
                                            Inbox
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item d-flex" to="/Chat">
                                            <i className="bx bx-envelope fs-18 me-2 op-7" />
                                            Messages
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            className="dropdown-item d-flex border-block-end"
                                            to="/Editprofile"
                                        >
                                            <i className="bx bx-slider-alt fs-18 me-2 op-7" />
                                            Account Settings
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="dropdown-item d-flex" to="/Signin">
                                            <i className="bx bx-log-out fs-18 me-2 op-7" />
                                            Sign Out
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            {/* End::header-element */}
                            {/* Start::header-element */}
                            <div className="header-element">

                            </div>
                            {/* End::header-element */}
                        </div>
                        {/* End::header-content-right */}
                    </div>
                    {/* End::main-header-container */}
                </header>
                {/* /app-header */}
                {/* Start::Off-canvas sidebar*/}
                <div
                    className="offcanvas offcanvas-end"
                    tabIndex={-1}
                    id="header-sidebar"
                    aria-labelledby="sidebarLabel"
                >
                    <div className="offcanvas-header rounded-0">
                        <h5 className="fs-14 text-uppercase mb-0 fw-semibold" id="sidebarLabel">
                            Notifications
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        />
                    </div>
                    <div className="offcanvas-body rounded-0 p-0">
                        <ul className="nav nav-tabs tab-style-1 d-block" role="tablist">
                            <li className="nav-item" role="presentation">
                                <Link
                                    className="nav-link"
                                    data-bs-toggle="tab"
                                    data-bs-target="#chat"
                                    aria-current="page"
                                    to="#chat"
                                    aria-selected="false"
                                    role="tab"
                                    tabIndex={-1}
                                >
                                    <i className="fe fe-message-circle fs-15 me-2" />
                                    Chat
                                </Link>
                            </li>
                            <li className="nav-item" role="presentation">
                                <Link
                                    className="nav-link"
                                    data-bs-toggle="tab"
                                    data-bs-target="#notifications"
                                    to="#notifications"
                                    aria-selected="false"
                                    role="tab"
                                    tabIndex={-1}
                                >
                                    <i className="fe fe-bell fs-15 me-2" /> Notifications
                                </Link>
                            </li>
                            <li className="nav-item mb-0" role="presentation">
                                <Link
                                    className="nav-link active"
                                    data-bs-toggle="tab"
                                    data-bs-target="#friends"
                                    to="#friends"
                                    aria-selected="true"
                                    role="tab"
                                >
                                    <i className="fe fe-users fs-15 me-2" />
                                    Friends
                                </Link>
                            </li>
                        </ul>
                        <div className="tab-content">
                            <div
                                className="tab-pane border-start-0 border-end-0 rounded-0 p-0"
                                id="chat"
                                role="tabpanel"
                            >
                                <div className="list d-flex align-items-center border-bottom p-3">
                                    <div className="">
                                        <span className="avatar bg-primary rounded-circle avatar-md">
                                            CH
                                        </span>
                                    </div>
                                    <Link className="wrapper w-100 ms-3" to="#">
                                        <p className="mb-0 d-flex ">
                                            <b>New Websites is Created</b>
                                        </p>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <i className="fa-regular fa-clock text-muted me-1 fs-11" />
                                                <small className="text-muted ms-auto">30 mins ago</small>
                                                <p className="mb-0" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="list d-flex align-items-center border-bottom p-3">
                                    <div className="">
                                        <span className="avatar bg-danger rounded-circle avatar-md">
                                            N
                                        </span>
                                    </div>
                                    <Link className="wrapper w-100 ms-3" to="#">
                                        <p className="mb-0 d-flex ">
                                            <b>Prepare For the Next Project</b>
                                        </p>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <i className="fa-regular fa-clock text-muted me-1 fs-11" />
                                                <small className="text-muted ms-auto">2 hours ago</small>
                                                <p className="mb-0" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="list d-flex align-items-center border-bottom p-3">
                                    <div className="">
                                        <span className="avatar bg-info rounded-circle avatar-md">
                                            S
                                        </span>
                                    </div>
                                    <Link className="wrapper w-100 ms-3" to="#">
                                        <p className="mb-0 d-flex ">
                                            <b>Decide the live Discussion</b>
                                        </p>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <i className="fa-regular fa-clock text-muted me-1 fs-11" />
                                                <small className="text-muted ms-auto">3 hours ago</small>
                                                <p className="mb-0" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="list d-flex align-items-center border-bottom p-3">
                                    <div className="">
                                        <span className="avatar bg-warning rounded-circle avatar-md">
                                            K
                                        </span>
                                    </div>
                                    <Link className="wrapper w-100 ms-3" to="#">
                                        <p className="mb-0 d-flex ">
                                            <b>Meeting at 3:00 pm</b>
                                        </p>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <i className="fa-regular fa-clock text-muted me-1 fs-11" />
                                                <small className="text-muted ms-auto">4 hours ago</small>
                                                <p className="mb-0" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="list d-flex align-items-center border-bottom p-3">
                                    <div className="">
                                        <span className="avatar bg-success rounded-circle avatar-md">
                                            R
                                        </span>
                                    </div>
                                    <Link className="wrapper w-100 ms-3" to="#">
                                        <p className="mb-0 d-flex ">
                                            <b>Prepare for Presentation</b>
                                        </p>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <i className="fa-regular fa-clock text-muted me-1 fs-11" />
                                                <small className="text-muted ms-auto">1 day ago</small>
                                                <p className="mb-0" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="list d-flex align-items-center border-bottom p-3">
                                    <div className="">
                                        <span className="avatar bg-pink rounded-circle avatar-md">
                                            MS
                                        </span>
                                    </div>
                                    <Link className="wrapper w-100 ms-3" to="#">
                                        <p className="mb-0 d-flex ">
                                            <b>Prepare for Presentation</b>
                                        </p>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <i className="fa-regular fa-clock text-muted me-1 fs-11" />
                                                <small className="text-muted ms-auto">1 day ago</small>
                                                <p className="mb-0" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="list d-flex align-items-center border-bottom p-3">
                                    <div className="">
                                        <span className="avatar bg-purple rounded-circle avatar-md">
                                            L
                                        </span>
                                    </div>
                                    <Link className="wrapper w-100 ms-3" to="#">
                                        <p className="mb-0 d-flex ">
                                            <b>Prepare for Presentation</b>
                                        </p>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <i className="fa-regular fa-clock text-muted me-1 fs-11" />
                                                <small className="text-muted ms-auto">45 minutes ago</small>
                                                <p className="mb-0" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="list d-flex align-items-center p-3">
                                    <div className="">
                                        <span className="avatar bg-blue rounded-circle avatar-md">
                                            U
                                        </span>
                                    </div>
                                    <Link className="wrapper w-100 ms-3" to="#">
                                        <p className="mb-0 d-flex ">
                                            <b>Prepare for Presentation</b>
                                        </p>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <i className="fa-regular fa-clock text-muted me-1 fs-11" />
                                                <small className="text-muted ms-auto">2 days ago</small>
                                                <p className="mb-0" />
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            <div
                                className="tab-pane border-start-0 border-end-0 rounded-0 p-0"
                                id="notifications"
                                role="tabpanel"
                            >
                                <div className="list-group list-group-flush ">
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-lg online avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/1.jpg" alt="img" />
                                        </span>
                                        <div className="ms-3">
                                            <strong>Madeleine</strong> Hey! there I' am available....
                                            <div className="small text-muted">3 hours ago</div>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-lg online avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/2.jpg" alt="img" />
                                        </span>
                                        <div className="ms-3">
                                            <strong>Anthony</strong> New product Launching...
                                            <div className="small text-muted">5 hour ago</div>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-lg avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/3.jpg" alt="img" />
                                        </span>
                                        <div className="ms-3">
                                            <strong>Olivia</strong> New Schedule Realease......
                                            <div className="small text-muted">45 minutes ago</div>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-lg avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/4.jpg" alt="img" />
                                        </span>
                                        <div className="ms-3">
                                            <strong>Madeleine</strong> Hey! there I' am available....
                                            <div className="small text-muted">3 hours ago</div>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-lg avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/5.jpg" alt="img" />
                                        </span>
                                        <div className="ms-3">
                                            <strong>Anthony</strong> New product Launching...
                                            <div className="small text-muted">5 hour ago</div>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-lg avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/6.jpg" alt="img" />
                                        </span>
                                        <div className="ms-3">
                                            <strong>Olivia</strong> New Schedule Realease......
                                            <div className="small text-muted">45 minutes ago</div>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-lg avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/7.jpg" alt="img" />
                                        </span>
                                        <div className="ms-3">
                                            <strong>Olivia</strong> Hey! there I' am available....
                                            <div className="small text-muted">12 minutes ago</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane border-start-0 border-end-0 rounded-0 p-0 active show"
                                id="friends"
                                role="tabpanel"
                            >
                                <div className="list-group list-group-flush ">
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md online avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/1.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Mozelle Belt
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/2.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Florinda Carasco
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/5.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Alina Bernier
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md online avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/6.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Zula Mclaughin
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md online avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/8.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Isidro Heide
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md online avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/8.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Mozelle Belt
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md online avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/9.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Florinda Carasco
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md online avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/10.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Alina Bernier
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/11.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Zula Mclaughin
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md online avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/12.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Isidro Heide
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md online avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/2.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Florinda Carasco
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md online avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/2.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Alina Bernier
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md online avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/3.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Zula Mclaughin
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="list-group-item d-flex  align-items-center">
                                        <span className="avatar avatar-md online avatar-rounded flex-shrink-0">
                                            <img src="assets/images/faces/4.jpg" alt="img" />
                                        </span>
                                        <div className="ms-2">
                                            <div
                                                className="fw-semibold"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                Isidro Heide
                                            </div>
                                        </div>
                                        <div className="ms-auto">
                                            <Link
                                                to="#"
                                                className="btn btn-sm btn-light"
                                                data-bs-toggle="modal"
                                                data-bs-target="#chatmodel"
                                            >
                                                <i className="fab fa-facebook-messenger" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End::Off-canvas sidebar*/}
                {/* Start::app-sidebar */}
                <aside className="app-sidebar sticky" id="sidebar" data-vertical-style={isToggled ? "overlay" : "hidden"}
                    data-toggled={isToggled ? "open" : "close"} >
                    {/* Start::main-sidebar-header */}
                    <div className="main-sidebar-header">
                        <Link to="/" className="header-logo">
                            <img
                                src="assets/images/brand-logos/desktop-logo.png"
                                alt="logo"
                                className="desktop-logo"
                            />
                            <img
                                src="assets/images/brand-logos/toggle-logo.png"
                                alt="logo"
                                className="toggle-logo"
                            />
                            <img
                                src="assets/images/brand-logos/desktop-white.png"
                                alt="logo"
                                className="desktop-white"
                            />
                            <img
                                src="assets/images/brand-logos/toggle-white.png"
                                alt="logo"
                                className="toggle-white"
                            />
                        </Link>
                    </div>
                    {/* End::main-sidebar-header */}
                    {/* Start::main-sidebar */}
                    <div className="main-sidebar" id="sidebar-scroll" >
                        {/* Start::nav */}
                        <nav className="main-menu-container nav nav-pills flex-column sub-open">
                            <div className="slide-left" id="slide-left">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="#7b8191"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                >
                                    {" "}
                                    <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" />{" "}
                                </svg>
                            </div>
                            <ul className="main-menu">
                                {/* Start::slide__category */}
                                <li className="slide__category">
                                    <span className="category-name">Main</span>

                                    <i class="fe fe-align-justify side-menu__angle" onClick={toggleSidebar}></i>
                                </li>
                                {/* End::slide__category */}
                                {/* Start::slide */}
                                <li className="slide">
                                    <Link to="/" className="side-menu__item">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="side-menu__icon"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                            <path
                                                d="M5 5h4v6H5zm10 8h4v6h-4zM5 17h4v2H5zM15 5h4v2h-4z"
                                                opacity=".3"
                                            />
                                            <path d="M3 13h8V3H3v10zm2-8h4v6H5V5zm8 16h8V11h-8v10zm2-8h4v6h-4v-6zM13 3v6h8V3h-8zm6 4h-4V5h4v2zM3 21h8v-6H3v6zm2-4h4v2H5v-2z" />
                                        </svg>
                                        <span className="side-menu__label">Index</span>
                                        <span className="badge bg-success ms-auto menu-badge">1</span>
                                    </Link>
                                </li>
                                {/* End::slide */}
                                {/* Start::slide__category */}
                                <li className="slide__category">
                                    <span className="category-name">General</span>
                                </li>
                                {/* End::slide__category */}
                                {/* Start::slide */}
                                <li className="slide">
                                    <Link to="/Icons" className="side-menu__item">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="side-menu__icon"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                            <path
                                                d="M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.5 4c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zm3.5 9.5c-2.33 0-4.32-1.45-5.12-3.5h1.67c.7 1.19 1.97 2 3.45 2s2.76-.81 3.45-2h1.67c-.8 2.05-2.79 3.5-5.12 3.5z"
                                                opacity=".3"
                                            />
                                            <circle cx="15.5" cy="9.5" r="1.5" />
                                            <circle cx="8.5" cy="9.5" r="1.5" />
                                            <path d="M12 16c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2zm-.01-14C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
                                        </svg>
                                        <span className="side-menu__label">Icons</span>
                                    </Link>
                                </li>
                                {/* End::slide */}
                                {/* Start::slide */}
                                <li className={`slide has-sub ${isOpenCharts ? 'open' : ''}`}>
                                    <Link to="#" className="side-menu__item" onClick={toggleMenuCharts}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="side-menu__icon"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                            <path
                                                d="M19 5H5v14h14V5zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
                                                opacity=".3"
                                            />
                                            <path d="M3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm2 0h14v14H5V5zm2 5h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z" />
                                        </svg>
                                        <span className="side-menu__label">Charts</span>
                                        <i className="fe fe-chevron-right side-menu__angle" />
                                    </Link>
                                    <ul className="slide-menu child1" style={{ display: isOpenCharts ? 'block' : 'none' }}>
                                        <li className="slide side-menu__label1">
                                            <Link to="#">Charts</Link>
                                        </li>
                                        <li className={`slide has-sub ${isOpenApexCharts ? 'open' : ''}`}>
                                            <Link to="#" className="side-menu__item" onClick={toggleMenuApexCharts}>
                                                Apex Charts
                                                <i className="fe fe-chevron-right side-menu__angle" />
                                            </Link>
                                            <ul className="slide-menu child2" style={{ display: isOpenApexCharts ? 'block' : 'none' }}>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-line-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Line Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-area-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Area Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-column-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Column Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-bar-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Bar Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-mixed-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Mixed Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-rangearea-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Range Area Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-timeline-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Timeline Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-candlestick-charts"
                                                        className="side-menu__item"
                                                    >
                                                        CandleStick Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-boxplot-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Boxplot Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-bubble-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Bubble Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-scatter-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Scatter Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-heatmap-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Heatmap Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-treemap-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Treemap Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-pie-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Pie Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-radialbar-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Radialbar Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-radar-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Radar Charts
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/apex-polararea-charts"
                                                        className="side-menu__item"
                                                    >
                                                        Polararea Charts
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="slide">
                                            <Link to="/chartjs-charts" className="side-menu__item">
                                                Chartjs Charts
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/echarts" className="side-menu__item">
                                                Echart Charts
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                {/* End::slide */}
                                {/* Start::slide__category */}
                                <li className="slide__category">
                                    <span className="category-name">Web Apps</span>
                                </li>
                                {/* End::slide__category */}
                                {/* Start::slide */}
                                <li className={`slide has-sub ${isOpenApps ? 'open' : ''}`}>
                                    <Link to="#" className="side-menu__item" onClick={toggleMenuApps}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="side-menu__icon"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                            <path
                                                d="M4 12c0 4.08 3.06 7.44 7 7.93V4.07C7.05 4.56 4 7.92 4 12z"
                                                opacity=".3"
                                            />
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z" />
                                        </svg>
                                        <span className="side-menu__label slide active">Apps</span>
                                        <i className="fe fe-chevron-right side-menu__angle" />
                                    </Link>
                                    <ul className="slide-menu child1" style={{ display: isOpenApps ? 'block' : 'none' }}>
                                        <li className="slide side-menu__label1">
                                            <Link to="#">Apps</Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Cards" className="side-menu__item">
                                                Cards
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/DraggableCards" className="side-menu__item slide active">
                                                Draggable Cards
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/FullCalendar" className="side-menu__item">
                                                Calendar
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Contacts" className="side-menu__item">
                                                Contacts
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Notifications" className="side-menu__item">
                                                Notifications
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Widgets" className="side-menu__item">
                                                Widgets
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link
                                                to="/widget-notification"
                                                className="side-menu__item"
                                            >
                                                Widget-notification
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/treeview" className="side-menu__item">
                                                Treeview
                                            </Link>
                                        </li>
                                        <li className={`slide has-sub ${isOpenElements ? 'open' : ''}`}>
                                            <Link to="#" className="side-menu__item" onClick={toggleFileManager}>
                                                File Manager
                                                <i className="fe fe-chevron-right side-menu__angle" />
                                            </Link>
                                            <ul className="slide-menu child2" style={{ display: isFileManager ? 'block' : 'none' }}>
                                                <li className="slide">
                                                    <Link to="/file-manager" className="side-menu__item">
                                                        File-Manager
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/file-manager-list"
                                                        className="side-menu__item"
                                                    >
                                                        File-Manager-List
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/file-manager-details"
                                                        className="side-menu__item"
                                                    >
                                                        File-Manager-details
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                {/* End::slide */}
                                {/* Start::slide */}
                                <li className={`slide has-sub ${isOpenElements ? 'open' : ''}`}>
                                    <Link to="#" className="side-menu__item" onClick={toggleMenuElements}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="side-menu__icon"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                            <path d="M6.26 9L12 13.47 17.74 9 12 4.53z" opacity=".3" />
                                            <path d="M19.37 12.8l-7.38 5.74-7.37-5.73L3 14.07l9 7 9-7zM12 2L3 9l1.63 1.27L12 16l7.36-5.73L21 9l-9-7zm0 11.47L6.26 9 12 4.53 17.74 9 12 13.47z" />
                                        </svg>
                                        <span className="side-menu__label">Elements</span>
                                        <i className="fe fe-chevron-right side-menu__angle" />
                                    </Link>
                                    <ul className="slide-menu child1 mega-menu" style={{ display: isOpenElements ? 'block' : 'none' }}>
                                        <li className="slide side-menu__label1">
                                            <Link to="#">Elements</Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Alerts" className="side-menu__item">
                                                Alerts
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Avatars" className="side-menu__item">
                                                Avatar
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Breadcrumb" className="side-menu__item">
                                                Breadcrumb
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Buttons" className="side-menu__item">
                                                Buttons
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Buttongroup" className="side-menu__item">
                                                Button Group
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Badge" className="side-menu__item">
                                                Badge
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Dropdowns" className="side-menu__item">
                                                Dropdown
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Listgroup" className="side-menu__item">
                                                List Group
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/links_interactions" className="side-menu__item">
                                                Links &amp; Interactions
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Navbar" className="side-menu__item">
                                                Navbar
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Images-figures" className="side-menu__item">
                                                Images &amp; Figures
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Pagination" className="side-menu__item">
                                                Pagination
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Popovers" className="side-menu__item">
                                                Popovers
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Progress" className="side-menu__item">
                                                Progress
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Spinners" className="side-menu__item">
                                                Spinners
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Typography" className="side-menu__item">
                                                Typography
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Tooltips" className="side-menu__item">
                                                Tooltips
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Toasts" className="side-menu__item">
                                                Toasts
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Tags" className="side-menu__item">
                                                Tags
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Navs-tabs" className="side-menu__item">
                                                Tabs
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Scrollspy" className="side-menu__item">
                                                Scrollspy
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Object-fit" className="side-menu__item">
                                                Object Fit
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                {/* End::slide */}
                                {/* Start::slide {`slide has-sub ${isOpenApps ? 'open' : ''}`}*/}
                                <li className={`slide has-sub ${isOpenAdvanced ? 'open' : ''}`}>
                                    <Link to="#" className="side-menu__item" onClick={toggleMenuAdvanced}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="side-menu__icon"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M0 0h24v24H0z" fill="none" />
                                            <path
                                                d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5 0-.16-.08-.28-.14-.35-.41-.46-.63-1.05-.63-1.65 0-1.38 1.12-2.5 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 10 6.5 10s1.5.67 1.5 1.5S7.33 13 6.5 13zm3-4C8.67 9 8 8.33 8 7.5S8.67 6 9.5 6s1.5.67 1.5 1.5S10.33 9 9.5 9zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 6 14.5 6s1.5.67 1.5 1.5S15.33 9 14.5 9zm4.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5z"
                                                opacity=".3"
                                            />
                                            <path d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10c1.38 0 2.5-1.12 2.5-2.5 0-.61-.23-1.21-.64-1.67-.08-.09-.13-.21-.13-.33 0-.28.22-.5.5-.5H16c3.31 0 6-2.69 6-6 0-4.96-4.49-9-10-9zm4 13h-1.77c-1.38 0-2.5 1.12-2.5 2.5 0 .61.22 1.19.63 1.65.06.07.14.19.14.35 0 .28-.22.5-.5.5-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.14 8 7c0 2.21-1.79 4-4 4z" />
                                            <circle cx="6.5" cy="11.5" r="1.5" />
                                            <circle cx="9.5" cy="7.5" r="1.5" />
                                            <circle cx="14.5" cy="7.5" r="1.5" />
                                            <circle cx="17.5" cy="11.5" r="1.5" />
                                        </svg>
                                        <span className="side-menu__label">Advanced Ui</span>
                                        <i className="fe fe-chevron-right side-menu__angle" />
                                    </Link>
                                    <ul className="slide-menu child1" style={{ display: isOpenAdvanced ? 'block' : 'none' }}>
                                        <li className="slide side-menu__label1">
                                            <Link to="#">Advanced Ui</Link>
                                        </li>
                                        <li className="slide">
                                            <Link
                                                to="/Accordions-collpase"
                                                className="side-menu__item"
                                            >
                                                Accordions
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Carousel" className="side-menu__item">
                                                Carousel
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Modals-closes" className="side-menu__item">
                                                Modals
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Timeline" className="side-menu__item">
                                                Timeline
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Sweet-alerts" className="side-menu__item">
                                                Sweet Alerts
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Ratings" className="side-menu__item">
                                                Ratings
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Search" className="side-menu__item">
                                                Search
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Userlist" className="side-menu__item">
                                                Userlist
                                            </Link>
                                        </li>
                                        <li className={`slide has-sub ${isOpenBlogPages ? 'open' : ""}`}>
                                            <Link to="#" className="side-menu__item" onClick={toggleMenuBlogPages}>
                                                Blog Pages
                                                <i className="fe fe-chevron-right side-menu__angle" />
                                            </Link>
                                            <ul className="slide-menu child2" style={{ display: isOpenBlogPages ? 'block' : 'none' }}>
                                                <li className="slide">
                                                    <Link to="/Blog" className="side-menu__item">
                                                        Blog
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/Blog-details" className="side-menu__item">
                                                        Blog Details
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/Blog-post" className="side-menu__item">
                                                        Blog Post
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Offcanvas" className="side-menu__item">
                                                Offcanvas
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Placeholders" className="side-menu__item">
                                                Placeholders
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Swiperjs" className="side-menu__item">
                                                Swiper JS
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                {/* End::slide */}
                                {/* Start::slide__category */}
                                <li className="slide__category">
                                    <span className="category-name">Multi Levels</span>
                                </li>
                                {/* End::slide__category */}
                                {/* Start::slide */}
                                <li className={`slide has-sub ${isOpenMenu ? 'open' : ''}`}>
                                    <Link to="#" className="side-menu__item" onClick={toggleMenuMenu}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="side-menu__icon"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                            <path
                                                d="M5 9h14V5H5v4zm2-3.5c.83 0 1.5.67 1.5 1.5S7.83 8.5 7 8.5 5.5 7.83 5.5 7 6.17 5.5 7 5.5zM5 19h14v-4H5v4zm2-3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5z"
                                                opacity=".3"
                                            />
                                            <path d="M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm-1 6H5v-4h14v4zm-12-.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zm-1 6H5V5h14v4zM7 8.5c.83 0 1.5-.67 1.5-1.5S7.83 5.5 7 5.5 5.5 6.17 5.5 7 6.17 8.5 7 8.5z" />
                                        </svg>
                                        <span className="side-menu__label">Menu Levels</span>
                                        <i className="fe fe-chevron-right side-menu__angle" />
                                    </Link>
                                    <ul className="slide-menu child1" style={{ display: isOpenMenu ? 'block' : 'none' }}>
                                        <li className="slide side-menu__label1">
                                            <Link to="#">Menu Levels</Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="#" className="side-menu__item">
                                                Level-1
                                            </Link>
                                        </li>
                                        <li className={`slide has-sub ${isOpenLevel2 ? 'open' : ''}`}>
                                            <Link to="#" className="side-menu__item" onClick={toggleMenuLevel2}>
                                                Level-2
                                                <i className="fe fe-chevron-right side-menu__angle" />

                                            </Link>
                                            <ul className="slide-menu child2" style={{ display: isOpenLevel2 ? 'block' : 'none' }}>
                                                <li className="slide">
                                                    <Link to="#" className="side-menu__item">
                                                        Level-2-1
                                                    </Link>
                                                </li>
                                                <li className={`slide has-sub ${isOpenLevel22 ? 'open' : ''}`}>
                                                    <Link to="#" className="side-menu__item" onClick={toggleMenuLevel22}>
                                                        Level-2-2
                                                        <i className="fe fe-chevron-right side-menu__angle" />
                                                    </Link>
                                                    <ul className="slide-menu child3" style={{ display: isOpenLevel22 ? 'block' : 'none' }}>
                                                        <li className="slide">
                                                            <Link
                                                                to="#"
                                                                className="side-menu__item"
                                                            >
                                                                Level-2-2-1
                                                            </Link>
                                                        </li>
                                                        <li className="slide">
                                                            <Link
                                                                to="#"
                                                                className="side-menu__item"
                                                            >
                                                                Level-2-2-2
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                {/* End::slide */}
                                {/* Start::slide__category */}
                                <li className="slide__category">
                                    <span className="category-name">Components</span>
                                </li>
                                {/* End::slide__category */}
                                {/* Start::slide */}
                                <li className={`slide has-sub ${isOpenForms ? 'open' : ''}`}>
                                    <Link to="#" className="side-menu__item" onClick={toggleMenuForms}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="side-menu__icon"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                            <path
                                                d="M13 4H6v16h12V9h-5V4zm3 14H8v-2h8v2zm0-6v2H8v-2h8z"
                                                opacity=".3"
                                            />
                                            <path d="M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z" />
                                        </svg>
                                        <span className="side-menu__label">Forms</span>
                                        <i className="fe fe-chevron-right side-menu__angle" />
                                    </Link>
                                    <ul className="slide-menu child1" style={{ display: isOpenForms ? 'block' : 'none' }}>
                                        <li className="slide side-menu__label1">
                                            <Link to="#">Forms</Link>
                                        </li>
                                        <li className={`slide has-sub ${isFormElements ? 'open' : ''}`}>
                                            <Link to="#" className="side-menu__item" onClick={toggleFormElements}>
                                                Form Elements
                                                <i className="fe fe-chevron-right side-menu__angle" />
                                            </Link>
                                            <ul className="slide-menu child2" style={{ display: isFormElements ? 'block' : 'none' }}>
                                                <li className="slide">
                                                    <Link to="/Form-inputs" className="side-menu__item">
                                                        Inputs
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/Form-check-radios"
                                                        className="side-menu__item"
                                                    >
                                                        Checks &amp; Radios
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/Form-input-group"
                                                        className="side-menu__item"
                                                    >
                                                        Input Group
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/Form-select" className="side-menu__item">
                                                        Form Select
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/Form-range" className="side-menu__item">
                                                        Range Slider
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/Form-input-masks"
                                                        className="side-menu__item"
                                                    >
                                                        Input Masks
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/Form-file-uploads"
                                                        className="side-menu__item"
                                                    >
                                                        File Uploads
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/Form-dateTime-pickers"
                                                        className="side-menu__item"
                                                    >
                                                        Date,Time Picker
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/Form-color-pickers"
                                                        className="side-menu__item"
                                                    >
                                                        Color Pickers
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Floating-labels" className="side-menu__item">
                                                Floating Labels
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Form-layout" className="side-menu__item">
                                                Form Layouts
                                            </Link>
                                        </li>
                                        <li className={`slide has-sub ${isFormEditors ? 'open' : ''}`}>
                                            <Link to="#" className="side-menu__item" onClick={toggleFormEditors}>
                                                Form Editors
                                                <i className="fe fe-chevron-right side-menu__angle" />
                                            </Link>
                                            <ul className="slide-menu child2" style={{ display: isFormEditors ? 'block' : 'none' }}>
                                                <li className="slide">
                                                    <Link to="/Quill_editor" className="side-menu__item">
                                                        Quill Editor
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Form-validation" className="side-menu__item">
                                                Validation
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Form-select2" className="side-menu__item">
                                                Select2
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                {/* End::slide */}
                                {/* Start::slide  {`slide has-sub ${isFormEditors ? 'open' : ''}`} */}
                                <li className={`slide has-sub ${isOpenTables ? 'open' : ''}`}>
                                    <Link to="#" className="side-menu__item" onClick={toggleOpenTables}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="side-menu__icon"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                            <path
                                                d="M5 5h15v3H5zm12 5h3v9h-3zm-7 0h5v9h-5zm-5 0h3v9H5z"
                                                opacity=".3"
                                            />
                                            <path d="M20 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8 19H5v-9h3v9zm7 0h-5v-9h5v9zm5 0h-3v-9h3v9zm0-11H5V5h15v3z" />
                                        </svg>
                                        <span className="side-menu__label">Tables</span>
                                        <i className="fe fe-chevron-right side-menu__angle" />
                                    </Link>
                                    <ul className="slide-menu child1" style={{ display: isOpenTables ? 'block' : 'none' }}>
                                        <li className="slide side-menu__label1">
                                            <Link to="#">Tables</Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Tables" className="side-menu__item">
                                                Tables
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Grid-tables" className="side-menu__item">
                                                Grid JS Tables
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Data-tables" className="side-menu__item">
                                                Data Tables
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                {/* End::slide */}
                                {/* Start::slide */}
                                <li className="slide">
                                    <Link to="/Landing-page" className="side-menu__item">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="side-menu__icon"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M0 0h24v24H0z" fill="none" />
                                            <path
                                                d="M12 4.02C7.6 4.02 4.02 7.6 4.02 12S7.6 19.98 12 19.98s7.98-3.58 7.98-7.98S16.4 4.02 12 4.02zM11.39 19v-5.5H8.25l4.5-8.5v5.5h3L11.39 19z"
                                                opacity=".3"
                                            />
                                            <path d="M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02zm0 17.96c-4.4 0-7.98-3.58-7.98-7.98S7.6 4.02 12 4.02 19.98 7.6 19.98 12 16.4 19.98 12 19.98zM12.75 5l-4.5 8.5h3.14V19l4.36-8.5h-3V5z" />
                                        </svg>
                                        <span className="side-menu__label">Landing Page</span>
                                    </Link>
                                </li>
                                {/* End::slide */}
                                {/* Start::slide */}
                                <li className={`slide has-sub ${isOpenMaps ? 'open' : ''}`}>
                                    <Link to="#" className="side-menu__item" onClick={toggleMenuMaps}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="side-menu__icon"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                            <path
                                                d="M12 4C9.24 4 7 6.24 7 9c0 2.85 2.92 7.21 5 9.88 2.11-2.69 5-7 5-9.88 0-2.76-2.24-5-5-5zm0 7.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                                                opacity=".3"
                                            />
                                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z" />
                                            <circle cx={12} cy={9} r="2.5" />
                                        </svg>
                                        <span className="side-menu__label">Maps</span>
                                        <i className="fe fe-chevron-right side-menu__angle" />
                                    </Link>
                                    <ul className="slide-menu child1" style={{ display: isOpenMaps ? 'block' : 'none' }}>
                                        <li className="slide side-menu__label1">
                                            <Link to="#">Maps</Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/GoogleMaps" className="side-menu__item">
                                                Google Maps
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/LeafletMaps" className="side-menu__item">
                                                Leaflet Maps
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="VectorMaps" className="side-menu__item">
                                                Vector Maps
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                {/* End::slide */}
                                {/* Start::slide__category */}
                                <li className="slide__category">
                                    <span className="category-name">Pages</span>
                                </li>
                                {/* End::slide__category */}
                                {/* Start::slide */}
                                <li className={`slide has-sub ${isOpenPages ? 'open' : ''}`}>
                                    <Link to="#" className="side-menu__item" onClick={toggleMenuPages}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            enableBackground="new 0 0 24 24"
                                            className="side-menu__icon"
                                            viewBox="0 0 24 24"
                                        >
                                            <g />
                                            <g>
                                                <g />
                                                <g>
                                                    <path d="M21,5c-1.11-0.35-2.33-0.5-3.5-0.5c-1.95,0-4.05,0.4-5.5,1.5c-1.45-1.1-3.55-1.5-5.5-1.5S2.45,4.9,1,6v14.65 c0,0.25,0.25,0.5,0.5,0.5c0.1,0,0.15-0.05,0.25-0.05C3.1,20.45,5.05,20,6.5,20c1.95,0,4.05,0.4,5.5,1.5c1.35-0.85,3.8-1.5,5.5-1.5 c1.65,0,3.35,0.3,4.75,1.05c0.1,0.05,0.15,0.05,0.25,0.05c0.25,0,0.5-0.25,0.5-0.5V6C22.4,5.55,21.75,5.25,21,5z M3,18.5V7 c1.1-0.35,2.3-0.5,3.5-0.5c1.34,0,3.13,0.41,4.5,0.99v11.5C9.63,18.41,7.84,18,6.5,18C5.3,18,4.1,18.15,3,18.5z M21,18.5 c-1.1-0.35-2.3-0.5-3.5-0.5c-1.34,0-3.13,0.41-4.5,0.99V7.49c1.37-0.59,3.16-0.99,4.5-0.99c1.2,0,2.4,0.15,3.5,0.5V18.5z" />
                                                    <path
                                                        d="M11,7.49C9.63,6.91,7.84,6.5,6.5,6.5C5.3,6.5,4.1,6.65,3,7v11.5C4.1,18.15,5.3,18,6.5,18 c1.34,0,3.13,0.41,4.5,0.99V7.49z"
                                                        opacity=".3"
                                                    />
                                                </g>
                                                <g>
                                                    <path d="M17.5,10.5c0.88,0,1.73,0.09,2.5,0.26V9.24C19.21,9.09,18.36,9,17.5,9c-1.28,0-2.46,0.16-3.5,0.47v1.57 C14.99,10.69,16.18,10.5,17.5,10.5z" />
                                                    <path d="M17.5,13.16c0.88,0,1.73,0.09,2.5,0.26V11.9c-0.79-0.15-1.64-0.24-2.5-0.24c-1.28,0-2.46,0.16-3.5,0.47v1.57 C14.99,13.36,16.18,13.16,17.5,13.16z" />
                                                    <path d="M17.5,15.83c0.88,0,1.73,0.09,2.5,0.26v-1.52c-0.79-0.15-1.64-0.24-2.5-0.24c-1.28,0-2.46,0.16-3.5,0.47v1.57 C14.99,16.02,16.18,15.83,17.5,15.83z" />
                                                </g>
                                            </g>
                                        </svg>
                                        <span className="side-menu__label">Pages</span>
                                        <i className="fe fe-chevron-right side-menu__angle" />
                                    </Link>
                                    <ul className="slide-menu child1" style={{ display: isOpenPages ? 'block' : 'none' }}>
                                        <li className="slide side-menu__label1">
                                            <Link to="#">Pages</Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Profile" className="side-menu__item">
                                                Profile
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Editprofile" className="side-menu__item">
                                                Edit-Profile
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/About" className="side-menu__item">
                                                About-Us
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Settings" className="side-menu__item">
                                                Settings
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Invoice" className="side-menu__item">
                                                Invoice
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Pricing" className="side-menu__item">
                                                Pricing
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Gallery" className="side-menu__item">
                                                Gallery
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Todotask" className="side-menu__item">
                                                Todotask
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Faq" className="side-menu__item">
                                                Faqs
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Empty" className="side-menu__item">
                                                Empty
                                            </Link>
                                        </li>
                                        <li className={`slide has-sub ${isMail ? 'open' : ''}`}>
                                            <Link to="#" className="side-menu__item" onClick={toggleMail}>
                                                Mail
                                                <i className="fe fe-chevron-right side-menu__angle" />
                                            </Link>
                                            <ul className="slide-menu child2" style={{ display: isMail ? 'block' : 'none' }}>
                                                <li className="slide">
                                                    <Link to="/Mail" className="side-menu__item">
                                                        Mail
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/MailCompose" className="side-menu__item">
                                                        Mail Compose
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/MailRead" className="side-menu__item">
                                                        Mail Read
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/MailSettings" className="side-menu__item">
                                                        Mail Settings
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/Chat" className="side-menu__item">
                                                        Chat
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className={`slide has-sub  ${isEcommerce ? 'open' : ''}`}>
                                            <Link to="#" className="side-menu__item" onClick={toggleEcommerce}>
                                                Ecommerce
                                                <i className="fe fe-chevron-right side-menu__angle" />
                                            </Link>
                                            <ul className="slide-menu child2" style={{ display: isEcommerce ? 'block' : 'none' }}>
                                                <li className="slide">
                                                    <Link to="/Products" className="side-menu__item">
                                                        Products
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/ProductDetails"
                                                        className="side-menu__item"
                                                    >
                                                        Product Details
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/ProductCart" className="side-menu__item">
                                                        Cart
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/CheckOut" className="side-menu__item">
                                                        Check-out
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/WishList" className="side-menu__item">
                                                        Wish List
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className={`slide has-sub ${isEcommerce ? 'open' : ''}`}>
                                            <Link to="#" className="side-menu__item" onClick={toggleCustomPages}>
                                                Custom Pages
                                                <i className="fe fe-chevron-right side-menu__angle" />
                                            </Link>
                                            <ul className="slide-menu child2" style={{ display: isCustomPages ? 'block' : 'none' }}>
                                                <li className="slide">
                                                    <Link to="/Signin" className="side-menu__item">
                                                        Sign In
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/Signup" className="side-menu__item">
                                                        Sign Up
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/Forgot" className="side-menu__item">
                                                        Forgot Password
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/Reset" className="side-menu__item">
                                                        Reset Password
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/Lockscreen" className="side-menu__item">
                                                        Lockscreen
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link
                                                        to="/UnderMaintenance"
                                                        className="side-menu__item"
                                                    >
                                                        Under Maintenance
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/Error404" className="side-menu__item">
                                                        404 Error
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/Error500" className="side-menu__item">
                                                        500 Error
                                                    </Link>
                                                </li>
                                                <li className="slide">
                                                    <Link to="/Error501" className="side-menu__item">
                                                        501 Error
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                {/* End::slide */}
                                {/* Start::slide */}
                                <li className={`slide has-sub ${isOpenUtilities ? 'open' : ''}`}>
                                    <Link to="#" className="side-menu__item" onClick={toggleMenuUtilities}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="side-menu__icon"
                                            viewBox="0 0 24 24"
                                        >
                                            <path d="M0 0h24v24H0V0z" fill="none" />
                                            <path
                                                d="M10.9 19.91c.36.05.72.09 1.1.09 2.18 0 4.16-.88 5.61-2.3L14.89 13l-3.99 6.91zm-1.04-.21l2.71-4.7H4.59c.93 2.28 2.87 4.03 5.27 4.7zM8.54 12L5.7 7.09C4.64 8.45 4 10.15 4 12c0 .69.1 1.36.26 2h5.43l-1.15-2zm9.76 4.91C19.36 15.55 20 13.85 20 12c0-.69-.1-1.36-.26-2h-5.43l3.99 6.91zM13.73 9h5.68c-.93-2.28-2.88-4.04-5.28-4.7L11.42 9h2.31zm-3.46 0l2.83-4.92C12.74 4.03 12.37 4 12 4c-2.18 0-4.16.88-5.6 2.3L9.12 11l1.15-2z"
                                                opacity=".3"
                                            />
                                            <path d="M12 22c5.52 0 10-4.48 10-10 0-4.75-3.31-8.72-7.75-9.74l-.08-.04-.01.02C13.46 2.09 12.74 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10zm0-2c-.38 0-.74-.04-1.1-.09L14.89 13l2.72 4.7C16.16 19.12 14.18 20 12 20zm8-8c0 1.85-.64 3.55-1.7 4.91l-4-6.91h5.43c.17.64.27 1.31.27 2zm-.59-3h-7.99l2.71-4.7c2.4.66 4.35 2.42 5.28 4.7zM12 4c.37 0 .74.03 1.1.08L10.27 9l-1.15 2L6.4 6.3C7.84 4.88 9.82 4 12 4zm-8 8c0-1.85.64-3.55 1.7-4.91L8.54 12l1.15 2H4.26C4.1 13.36 4 12.69 4 12zm6.27 3h2.3l-2.71 4.7c-2.4-.67-4.35-2.42-5.28-4.7h5.69z" />
                                        </svg>
                                        <span className="side-menu__label">Utilities</span>
                                        <i className="fe fe-chevron-right side-menu__angle" />
                                    </Link>
                                    <ul className="slide-menu child1" style={{ display: isOpenUtilities ? 'block' : 'none' }}>
                                        <li className="slide side-menu__label1">
                                            <Link to="#">Utilities</Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Borders" className="side-menu__item">
                                                Borders
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Breakpoints" className="side-menu__item">
                                                Breakpoints
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Colors" className="side-menu__item">
                                                Colors
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Columns" className="side-menu__item">
                                                Columns
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Flex" className="side-menu__item">
                                                Flex
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Gutters" className="side-menu__item">
                                                Gutters
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Helpers" className="side-menu__item">
                                                Helpers
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/Position" className="side-menu__item">
                                                Position
                                            </Link>
                                        </li>
                                        <li className="slide">
                                            <Link to="/More" className="side-menu__item">
                                                Additional Content
                                            </Link>
                                        </li>
                                    </ul>
                                </li>
                                {/* End::slide */}
                            </ul>
                            <div className="slide-right" id="slide-right">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="#7b8191"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                >
                                    {" "}
                                    <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" />{" "}
                                </svg>
                            </div>
                        </nav>
                        {/* End::nav */}
                    </div>
                    {/* End::main-sidebar */}
                </aside>
                {/* End::app-sidebar */}
                {/*APP-CONTENT START*/}
                <div className="main-content app-content">
                    <div className="container-fluid">
                        {/* Page Header */}
                        <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                            <div className="my-auto">
                                <h5 className="page-title fs-21 mb-1">Cards</h5>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item"><a href="javascript:void(0);">Apps</a></li>
                                        <li className="breadcrumb-item active" aria-current="page">Cards</li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="d-flex my-xl-auto right-content align-items-center">
                                <div className="pe-1 mb-xl-0">
                                    <button type="button" className="btn btn-info btn-icon me-2 btn-b"><i className="mdi mdi-filter-variant" /></button>
                                </div>
                                <div className="pe-1 mb-xl-0">
                                    <button type="button" className="btn btn-danger btn-icon me-2"><i className="mdi mdi-star" /></button>
                                </div>
                                <div className="pe-1 mb-xl-0">
                                    <button type="button" className="btn btn-warning  btn-icon me-2"><i className="mdi mdi-refresh" /></button>
                                </div>
                                <div className="mb-xl-0">
                                    <div className="dropdown">
                                        <button className="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuDate" data-bs-toggle="dropdown" aria-expanded="false">
                                            14 Aug 2019
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuDate">
                                            <li><a className="dropdown-item" href="javascript:void(0);">2015</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0);">2016</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0);">2017</a></li>
                                            <li><a className="dropdown-item" href="javascript:void(0);">2018</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Page Header Close */}
                        {/* Start::row-1 */}
                        <div className="row">
                            <div className="col-xxl-3 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <div className="card custom-card">
                                    <img src="../assets/images/media/media-22.jpg" className="card-img-top" alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title fw-semibold">Card title</h6>
                                        <p className="card-text text-muted">when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                                        <a href="javascript:void(0);" className="btn btn-primary">Read More</a>
                                    </div>
                                    <div className="card-footer">
                                        <span className="card-text">Last updated 3 mins ago</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-3 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <div className="card custom-card">
                                    <div className="card-header">
                                        <div className="card-title">Featured</div>
                                    </div>
                                    <div className="card-body">
                                        <h6 className="card-subtitle fw-semibold mb-2">Special title treatment</h6>
                                        <p className="card-text">Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage</p>
                                        <a href="javascript:void(0);" className="btn btn-primary">Read More</a>
                                    </div>
                                </div>
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <h6 className="card-title fw-semibold mb-2">Card title</h6>
                                        <p className="card-subtitle mb-3 text-muted">Card subtitle</p>
                                        <p className="card-text">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration many variations of passages of Lorem Ipsum available there are so many ways to solve but the majority have suffered.</p>
                                    </div>
                                    <div className="card-footer">
                                        <a href="javascript:void(0);" className="card-link text-danger m-1">Buy Now</a>
                                        <a href="javascript:void(0);" className="card-link text-success m-1"><u>Review</u></a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-3 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <div className="card custom-card">
                                    <img src="../assets/images/media/media-23.jpg" className="card-img-top" alt="..." />
                                    <div className="card-body">
                                        <p className="card-text">Some quick example text to build on the card title and
                                            make up the bulk of the card's content.</p>
                                    </div>
                                </div>
                                <h6 className="mb-3">Only Card Body:</h6>
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <div className="card-text">
                                            <p className="mb-0">It is a long established fact that a reader will be distracted by the readable content.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-3 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                <div className="card custom-card">
                                    <img src="../assets/images/media/media-24.jpg" className="card-img-top" alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title fw-semibold">Card title</h6>
                                        <p className="card-text">Some quick example text to build on the card title and
                                            make up the bulk of the card's content.</p>
                                    </div>
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item">An item</li>
                                        <li className="list-group-item">A second item</li>
                                    </ul>
                                    <div className="card-body">
                                        <a href="javascript:void(0);" className="card-link text-primary">Card link</a>
                                        <a href="javascript:void(0);" className="card-link text-secondary d-inline-block">Another link</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End::row-1 */}
                        {/* Start::row-2 */}
                        <div className="row">
                            <div className="col-xxl-6 col-xl-6 col-lg-12">
                                <div className="row">
                                    <h6 className="mb-3">Quote:</h6>
                                    <div className="col-xl-12">
                                        <div className="card custom-card">
                                            <div className="card-body">
                                                <blockquote className="blockquote mb-0 text-center">
                                                    <h6>The greatest glory in living lies not in never falling, but in rising every time we fall.</h6>
                                                    <footer className="blockquote-footer mt-2 fs-14">Someone famous in <cite title="Source Title">Source Title</cite></footer>
                                                </blockquote>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-12">
                                        <h6 className="mb-3">List Group:</h6>
                                        <div className="row">
                                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4">
                                                <div className="card custom-card">
                                                    <ul className="list-group list-group-flush">
                                                        <li className="list-group-item">An item</li>
                                                        <li className="list-group-item">A second item</li>
                                                        <li className="list-group-item">A third item</li>
                                                        <li className="list-group-item">A fourth item</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4">
                                                <div className="card">
                                                    <div className="card-header border-bottom">
                                                        Featured
                                                    </div>
                                                    <ul className="list-group list-group-flush">
                                                        <li className="list-group-item">An item</li>
                                                        <li className="list-group-item">A second item</li>
                                                        <li className="list-group-item">A third item</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4">
                                                <div className="card custom-card">
                                                    <ul className="list-group list-group-flush">
                                                        <li className="list-group-item">An item</li>
                                                        <li className="list-group-item">A second item</li>
                                                        <li className="list-group-item">A third item</li>
                                                    </ul>
                                                    <div className="card-footer">
                                                        Card footer
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-6 col-xl-6 col-lg-12">
                                <h6 className="mb-3">Using Grid Markups:</h6>
                                <div className="row row-cols-12">
                                    <div className="col">
                                        <div className="card custom-card">
                                            <div className="card-body">
                                                <img src="../assets/images/media/media-25.jpg" className="card-img mb-3" alt="..." />
                                                <h6 className="card-title fw-semibold">Product A</h6>
                                                <p className="card-text">With supporting text below as a natural
                                                    lead-in to additional content.</p>
                                                <a href="javascript:void(0);" className="btn btn-primary">Purchase</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="card custom-card">
                                            <div className="card-body">
                                                <img src="../assets/images/media/media-26.jpg" className="card-img mb-3" alt="..." />
                                                <h6 className="card-title fw-semibold">Product B</h6>
                                                <p className="card-text">With supporting text below as a natural
                                                    lead-in to additional content.</p>
                                                <a href="javascript:void(0);" className="btn btn-info">Purchase</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="card custom-card">
                                            <div className="card-body">
                                                <img src="../assets/images/media/media-27.jpg" className="card-img mb-3" alt="..." />
                                                <h6 className="card-title fw-semibold">Product-C</h6>
                                                <p className="card-text">With supporting text below as a natural
                                                    lead-in to additional content.</p>
                                                <a href="javascript:void(0);" className="btn btn-light">Purchase</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End::row-2 */}
                        {/* Start::row-3*/}
                        <div className="row">
                            <div className="col-xl-9">
                                <h6 className="mb-3">Text Alignment:</h6>
                                <div className="row">
                                    <div className="col-xl-4">
                                        <div className="card custom-card">
                                            <div className="card-body">
                                                <div className="mb-2">
                                                    <span className="avatar avatar-md">
                                                        <img src="../assets/images/faces/15.jpg" alt="img" />
                                                    </span>
                                                </div>
                                                <h6 className="card-title fw-semibold">Where it come from</h6>
                                                <p className="card-text">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature.</p>
                                                <a href="javascript:void(0);" className="btn btn-primary">Go somewhere</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4">
                                        <div className="card text-center custom-card">
                                            <div className="card-body">
                                                <div className="mb-2">
                                                    <span className="avatar avatar-md">
                                                        <img src="../assets/images/faces/3.jpg" alt="img" />
                                                    </span>
                                                </div>
                                                <h6 className="card-title fw-semibold">Why do we use it?</h6>
                                                <p className="card-text">Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text.</p>
                                                <a href="javascript:void(0);" className="btn btn-primary">Go somewhere</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4">
                                        <div className="card text-end custom-card">
                                            <div className="card-body">
                                                <div className="mb-2">
                                                    <span className="avatar avatar-md">
                                                        <img src="../assets/images/faces/11.jpg" alt="img" />
                                                    </span>
                                                </div>
                                                <h6 className="card-title fw-semibold">What is special?</h6>
                                                <p className="card-text">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.</p>
                                                <a href="javascript:void(0);" className="btn btn-primary">Go somewhere</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="row">
                                    <h6 className="mb-3">Mixins utilities:</h6>
                                    <div className="col-xl-12">
                                        <div className="card border border-success mb-3">
                                            <div className="card-header bg-transparent border-bottom border-success">Header</div>
                                            <div className="card-body text-success">
                                                <h6 className="card-title fw-semibold">Looking For Success?</h6>
                                                <p className="card-text">If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
                                            </div>
                                            <div className="card-footer bg-transparent border-top border-success">Footer</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End::row-3*/}
                        {/* Start::row-4 */}
                        <h6 className="mb-3">Card Header &amp; Footer:</h6>
                        <div className="row">
                            <div className="col-xl-3">
                                <div className="card custom-card">
                                    <div className="card-header">
                                        <div className="d-flex align-items-center w-100">
                                            <div className="me-2">
                                                <span className="avatar avatar-rounded">
                                                    <img src="../assets/images/faces/11.jpg" alt="img" />
                                                </span>
                                            </div>
                                            <div className>
                                                <div className="fs-15 fw-semibold">Adam Smith</div>
                                                <p className="mb-0 text-muted fs-11">28 Years, Male</p>
                                            </div>
                                            <div className="dropdown ms-auto">
                                                <a href="javascript:void(0);" className="btn btn-icon btn-sm btn-light" data-bs-toggle="dropdown">
                                                    <i className="fe fe-more-vertical" />
                                                </a>
                                                <ul className="dropdown-menu">
                                                    <li><a className="dropdown-item" href="javascript:void(0);">Week</a></li>
                                                    <li><a className="dropdown-item" href="javascript:void(0);">Month</a></li>
                                                    <li><a className="dropdown-item" href="javascript:void(0);">Year</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        If you are going to use, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators.Lorem Ipsum is therefore always free.
                                    </div>
                                    <div className="card-footer">
                                        <div className="d-flex justify-content-between">
                                            <div className="fs-semibold fs-14">28,Nov 2022</div>
                                            <div className="fw-semibold text-success">Assistant Professor</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card custom-card">
                                    <div className="card-header border-bottom-0 pb-0">
                                        <div className="fs-13">
                                            <span className="text-warning me-1"><i className="bi bi-star-fill" /></span>
                                            <span className="text-warning me-1"><i className="bi bi-star-fill" /></span>
                                            <span className="text-warning me-1"><i className="bi bi-star-fill" /></span>
                                            <span className="text-warning me-1"><i className="bi bi-star-fill" /></span>
                                            <span className="text-black op-1"><i className="bi bi-star-fill" /></span>
                                            <p className="d-block text-muted mb-0 fs-12 fw-semibold">1 year ago</p>
                                        </div>
                                    </div>
                                    <div className="card-body pt-3">
                                        <div className="fw-semibold fs-15 mb-2">Very Great!</div>
                                        There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour
                                    </div>
                                    <div className="card-footer">
                                        <div className="d-flex align-items-center">
                                            <span className="avatar avatar-sm avatar-rounded me-2">
                                                <img src="../assets/images/faces/12.jpg" alt="img" />
                                            </span>
                                            <div className="fw-semibold fs-14">Corey Anderson</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card custom-card text-center">
                                    <div className="card-header d-flex align-items-center">
                                        <span className="ms-auto fs-17"><i className="ri-heart-fill text-danger" /></span>
                                    </div>
                                    <div className="card-body pt-1">
                                        <span className="avatar avatar-xl avatar-rounded me-2 mb-2">
                                            <img src="../assets/images/faces/5.jpg" alt="img" />
                                        </span>
                                        <div className="fw-medium fs-16">Sasha Max</div>
                                        <p className="mb-4 text-muted fs-12">Web Developer</p>
                                        <div className="btn-list">
                                            <button className="btn btn-icon btn-facebook btn-wave">
                                                <i className="ri-facebook-line" />
                                            </button>
                                            <button className="btn btn-icon btn-twitter btn-wave">
                                                <i className="ri-twitter-x-line" />
                                            </button>
                                            <button className="btn btn-icon btn-instagram btn-wave">
                                                <i className="ri-instagram-line" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card custom-card border border-primary">
                                    <div className="card-body">
                                        <svg className="footer-card-icon my-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#C6CDD1" d="M19 21H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2z" /><path fill="#C6CDD1" d="M11 1H3a2 2 0 0 0-2 2v8h10V1z" /><path fill="#A1ABB2" d="M21 11V3a2 2 0 0 0-2-2h-8v10h10z" /><path fill="#878A8F" d="M1 11v8a2 2 0 0 0 2 2h8V11H1z" /><path fill="#797D82" d="M11 11v10h8a2 2 0 0 0 2-2v-8H11z" /><path fill="#FFF" d="M14 6h5v1h-5z" /><path d="M19 20.75H3a2 2 0 0 1-2-2V19a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-.25a2 2 0 0 1-2 2z" opacity=".1" /><circle cx={16} cy={16} r={7} fill="#136ad0" /><path d="M16 22.75c-3.08 0-5.704-1.97-6.696-4.713C10.18 20.907 12.85 23 16 23s5.82-2.094 6.696-4.963C21.704 20.781 19.08 22.75 16 22.75z" opacity=".1" /><path fill="#FFF" d="M16 9.25c3.08 0 5.704 1.97 6.696 4.713C21.82 11.093 19.15 9 16 9s-5.82 2.094-6.696 4.963C10.296 11.219 12.92 9.25 16 9.25z" opacity=".2" /><path fill="#FFF" d="M4 6h5v1H4z" /><path fill="#FFF" d="M6 4h1v5H6zM13 14h6v1h-6zM13 17h6v1h-6zM4.379 15.086l.707-.707 3.535 3.535-.707.707z" /><path fill="#FFF" d="m4.379 17.914 3.535-3.535.707.707-3.535 3.535z" /><path fill="#FFF" d="M19 1H3a2 2 0 0 0-2 2v.25a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2V3a2 2 0 0 0-2-2z" opacity=".2" /><linearGradient id="a" x1="14.367" x2="19.862" y1="14.367" y2="19.862" gradientUnits="userSpaceOnUse"><stop offset={0} stopColor="#3E2723" stopOpacity=".2" /><stop offset={1} stopColor="#3E2723" stopOpacity=".02" /></linearGradient><path fill="url(#a)" d="M19 14v1h-6l2 2h4v1h-6l4.766 4.766a7.014 7.014 0 0 0 5-5L19 14z" /><linearGradient id="b" x1="-.448" x2="23.366" y1="5.662" y2="16.766" gradientUnits="userSpaceOnUse"><stop offset={0} stopColor="#FFF" stopOpacity=".2" /><stop offset={1} stopColor="#FFF" stopOpacity={0} /></linearGradient><path fill="url(#b)" d="M21 11.11V3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8.11A6.974 6.974 0 0 0 16 23c3.86 0 7-3.14 7-7a6.974 6.974 0 0 0-2-4.89z" /></svg>
                                        <p className="mb-0 mt-3 fs-20 fw-semibold lh-1">
                                            Calculations
                                        </p>
                                    </div>
                                    <div className="card-footer">
                                        Lorem Ipsum is therefore always free from repetition, injected humour.
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-2">
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <img src="../assets/images/media/media-4.jpg" className="card-img mb-3" alt="..." />
                                        <h6 className="card-title fw-semibold mb-3">Mountains<span className="badge bg-primary float-end fs-10">New</span></h6>
                                        <p className="card-text">With supporting text below as a natural
                                            lead-in.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-2">
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <img src="../assets/images/media/media-5.jpg" className="card-img mb-3" alt="..." />
                                        <h6 className="card-title fw-semibold mb-3">Hills<span className="badge bg-secondary float-end fs-10">Hot</span></h6>
                                        <p className="card-text">With supporting text below as a natural
                                            lead-in.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-2">
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <img src="../assets/images/media/media-15.jpg" className="card-img mb-3" alt="..." />
                                        <h6 className="card-title fw-semibold mb-3">Nature<span className="badge bg-light text-dark float-end fs-10">Offer</span></h6>
                                        <p className="card-text">With supporting text below as a natural
                                            lead-in.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card custom-card text-center">
                                    <div className="card-header d-flex align-items-center">
                                        <div className="card-title">Featured</div>
                                    </div>
                                    <div className="card-body">
                                        <h6 className="card-title fw-semibold mb-2">Breaking News !</h6>
                                        <p className="card-text mb-4">With supporting text below as a natural lead-in to
                                            additional content.</p>
                                        <a href="javascript:void(0);" className="btn btn-primary mt-2">Read More</a>
                                        <a href="javascript:void(0);" className="btn btn-outline-danger mt-2">Close</a>
                                    </div>
                                    <div className="card-footer text-muted">
                                        11.32pm
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card custom-card">
                                    <div className="card-header">
                                        <div className="d-flex w-100">
                                            <div className="me-4">
                                                <span className="avatar avatar-lg avatar-rounded">
                                                    <img src="../assets/images/faces/12.jpg" alt="img" />
                                                </span>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between w-100 flex-wrap">
                                                <div className="me-3">
                                                    <p className="text-muted mb-0">Posts</p>
                                                    <p className="fw-semibold fs-16 mb-0">25</p>
                                                </div>
                                                <div className="me-3">
                                                    <p className="text-muted mb-0">Followers</p>
                                                    <p className="fw-semibold fs-16 mb-0">1253</p>
                                                </div>
                                                <div className="me-3">
                                                    <p className="text-muted mb-0">Following</p>
                                                    <p className="fw-semibold fs-16 mb-0">367</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="fw-semibold fs-16">Angelina Caprio</div>
                                        <div className="text-muted fs-11 mb-4">Angular Developer</div>
                                        <p className="fs-14 fw-semibold mb-1">About:</p>
                                        <p className="mb-0 card-text">Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card custom-card collapse-card">
                                    <div className="card-header d-flex align-items-center justify-content-between">
                                        <div className="card-title mb-0">
                                            Card With Collapse Button
                                        </div>
                                        <a href="javascript:void(0);" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                                            <i className="ri-arrow-down-s-line fs-18 collapse-open" />
                                            <i className="ri-arrow-up-s-line collapse-close fs-18" />
                                        </a>
                                    </div>
                                    <div className="collapse show" id="collapseExample">
                                        <div className="card-body">
                                            <h6 className="card-text fw-medium">Collapsible Card</h6>
                                            <p className="card-text mb-0">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words</p>
                                        </div>
                                        <div className="card-footer">
                                            <button className="btn btn-primary">Read More</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card custom-card">
                                    <div className="card-header d-flex align-items-center justify-content-between">
                                        <div className="card-title mb-0">
                                            Card With Close Button
                                        </div>
                                        <a href="javascript:void(0);" data-bs-toggle="card-remove">
                                            <i className="ri-close-line fs-18" />
                                        </a>
                                    </div>
                                    <div className="card-body">
                                        <h6 className="card-text fw-medium">Closed Card</h6>
                                        <p className="card-text mb-0">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words</p>
                                    </div>
                                    <div className="card-footer">
                                        <button className="btn btn-primary">Read More</button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card custom-card">
                                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap">
                                        <div className="card-title mb-0 text-wrap text-break">
                                            Card With Fullscreen Button
                                        </div>
                                        <a href="javascript:void(0);" data-bs-toggle="card-fullscreen" className="flex-shrink-0 ms-3">
                                            <i className="ri-fullscreen-line" />
                                        </a>
                                    </div>
                                    <div className="card-body">
                                        <h6 className="card-text fw-medium">FullScreen Card</h6>
                                        <p className="card-text mb-0">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words</p>
                                    </div>
                                    <div className="card-footer">
                                        <button className="btn btn-primary">Read More</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End::row-4 */}
                        {/* Start::row-5 */}
                        <div className="row">
                            <div className="col-xxl-6 col-xl-12">
                                <h6 className="mb-3">Using Utilities:</h6>
                                <div className="row">
                                    <div className="col-xl-6">
                                        <div className="card custom-card w-75">
                                            <div className="card-header">
                                                <div className="card-title">Using Width 75%</div>
                                            </div>
                                            <div className="card-body">
                                                <div className="card-text">
                                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Id nostrum omnis excepturi consequatur molestiae
                                                </div>
                                            </div>
                                            <div className="card-footer">
                                                <a href="javascript:void(0);" className="btn btn-primary d-grid">Button</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6">
                                        <div className="card custom-card w-50">
                                            <div className="card-header">
                                                <div className="card-title">Using Width 50%</div>
                                            </div>
                                            <div className="card-body">
                                                <div className="card-text">
                                                    Lorem ipsum dolor sit amet consectetur adipisicing elit
                                                </div>
                                            </div>
                                            <div className="card-footer">
                                                <a href="javascript:void(0);" className="btn btn-primary d-grid">Button</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-6 col-xl-12">
                                <h6 className="mb-3">Navigation:</h6>
                                <div className="row">
                                    <div className="col-xl-6">
                                        <div className="card custom-card text-center">
                                            <div className="card-header">
                                                <ul className="nav nav-tabs card-header-tabs ms-1">
                                                    <li className="nav-item">
                                                        <a className="nav-link active" aria-current="true" href="javascript:void(0);">Active</a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className="nav-link" href="javascript:void(0);">Link</a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className="nav-link disabled">Disabled</a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="card-body">
                                                <h6 className="card-title fw-semibold">Special title treatment</h6>
                                                <p className="card-text">With supporting text below as a natural lead-in to
                                                    additional content.</p>
                                                <a href="javascript:void(0);" className="btn btn-primary">Go somewhere</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6">
                                        <div className="card text-center custom-card">
                                            <div className="card-header">
                                                <ul className="nav nav-pills card-header-pills ms-1">
                                                    <li className="nav-item">
                                                        <a className="nav-link active" href="javascript:void(0);">Active</a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className="nav-link" href="javascript:void(0);">Link</a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className="nav-link disabled">Disabled</a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="card-body">
                                                <h6 className="card-title fw-semibold">Special title treatment</h6>
                                                <p className="card-text">With supporting text below as a natural lead-in to
                                                    additional content.</p>
                                                <a href="javascript:void(0);" className="btn btn-primary">Go somewhere</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End::row-5 */}
                        {/* Start::row-6 */}
                        <h6 className="mb-3">Image Caps:</h6>
                        <div className="row">
                            <div className="col-xl-4">
                                <div className="card custom-card">
                                    <img src="../assets/images/media/media-29.jpg" className="card-img-top" alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title fw-semibold">Image caps are widely used in Blog's</h6>
                                        <p className="card-text mb-3 text-muted">But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings.</p>
                                        <p className="card-text mb-0"><small>Last updated 3 mins
                                            ago</small></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <h6 className="card-title fw-semibold">Image caps are widely used in Blog's</h6>
                                        <p className="card-text mb-3 text-muted">But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound.</p>
                                        <p className="card-text mb-0"><small>Last updated 3 mins
                                            ago</small></p>
                                    </div>
                                    <img src="../assets/images/media/media-28.jpg" className="card-img-bottom" alt="..." />
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <h6 className="card-title fw-semibold mb-1">Image caps are widely used in Blog's</h6>
                                        <p className="card-text mb-1 text-muted">This is a wider card with supporting text below
                                            as
                                            a natural lead-in to additional content. This content is a
                                            little
                                            bit longer.</p>
                                    </div>
                                    <img src="../assets/images/media/media-30.jpg" className="card-img rounded-0" alt="..." />
                                    <div className="card-body">
                                        <p className="card-text mb-0"><small>Last updated 3 mins
                                            ago</small></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card custom-card">
                                    <div className="card-header">
                                        <div className="card-title">Image caps are widely used in Blog's</div>
                                    </div>
                                    <div className="card-body">
                                        <p className="card-text mb-1 text-muted">This is a wider card with supporting text below
                                            as
                                            a natural lead-in to additional content. This content is a
                                            little
                                            bit longer.</p>
                                    </div>
                                    <img src="../assets/images/media/media-31.jpg" className="card-img rounded-0" alt="..." />
                                    <div className="card-footer">
                                        <p className="card-text mb-0"><small>Last updated 3 mins
                                            ago</small></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card custom-card">
                                    <img src="../assets/images/media/media-32.jpg" className="card-img-top" alt="..." />
                                    <div className="card-header">
                                        <div className="card-title">Image caps are widely used in Blog's</div>
                                    </div>
                                    <div className="card-body">
                                        <p className="card-text mb-1 text-muted">This is a wider card with supporting text below
                                            as
                                            a natural lead-in to additional content. This content is a
                                            little
                                            bit longer.</p>
                                    </div>
                                    <div className="card-footer">
                                        <p className="card-text mb-0"><small>Last updated 3 mins
                                            ago</small></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card custom-card">
                                    <div className="card-header">
                                        <div className="card-title">Image caps are widely used in Blog's</div>
                                    </div>
                                    <div className="card-body">
                                        <p className="card-text mb-1 text-muted">This is a wider card with supporting text below
                                            as
                                            a natural lead-in to additional content. This content is a
                                            little
                                            bit longer.</p>
                                    </div>
                                    <div className="card-footer">
                                        <p className="card-text mb-0"><small>Last updated 3 mins
                                            ago</small></p>
                                    </div>
                                    <img src="../assets/images/media/media-33.jpg" className="card-img-bottom" alt="..." />
                                </div>
                            </div>
                        </div>
                        {/* End::row-6 */}
                        {/* Start::row-7 */}
                        <h6 className="mb-3">Image Overlays:</h6>
                        <div className="row">
                            <div className="col-xl-4">
                                <div className="card custom-card overlay-card">
                                    <img src="../assets/images/media/media-84.jpg" className="card-img" alt="..." />
                                    <div className="card-img-overlay d-flex flex-column p-0">
                                        <div className="card-header">
                                            <div className="card-title text-fixed-white">
                                                Image Overlays Are Awesome!
                                            </div>
                                        </div>
                                        <div className="card-body text-fixed-white overflow-scroll">
                                            <div className="card-text mb-2">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even.</div>
                                            <div className="card-text">Last updated 3 mins ago</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card custom-card overlay-card">
                                    <img src="../assets/images/media/media-83.jpg" className="card-img" alt="..." />
                                    <div className="card-img-overlay d-flex flex-column p-0 over-content-bottom">
                                        <div className="card-body text-fixed-white">
                                            <div className="card-text text-fixed-white">
                                                Image Overlays Are Awesome!
                                            </div>
                                            <div className="card-text mb-2 d-none d-sm-block">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even.</div>
                                            <div className="card-text">Last updated 3 mins ago</div>
                                        </div>
                                        <div className="card-footer text-fixed-white">Last updated 3 mins ago</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card custom-card overlay-card">
                                    <img src="../assets/images/media/media-82.jpg" className="card-img" alt="..." />
                                    <div className="card-img-overlay d-flex flex-column p-0">
                                        <div className="card-header">
                                            <div className="card-title text-fixed-white">
                                                Image Overlays Are Awesome!
                                            </div>
                                        </div>
                                        <div className="card-body text-fixed-white">
                                            <div className="card-text">There are many variations of passages of Lorem Ipsum available.</div>
                                        </div>
                                        <div className="card-footer text-fixed-white">Last updated 3 mins ago</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End::row-7 */}
                        {/* Start::row-8 */}
                        <h6 className="mb-3">Horizontal Cards:</h6>
                        <div className="row">
                            <div className="col-xl-4">
                                <div className="card custom-card">
                                    <div className="row g-0">
                                        <div className="col-md-4">
                                            <img src="../assets/images/media/media-37.jpg" className="img-fluid rounded-start h-100 w-100" alt="..." />
                                        </div>
                                        <div className="col-md-8">
                                            <div className="card-header">
                                                <div className="card-title">Horizontal Cards</div>
                                            </div>
                                            <div className="card-body">
                                                <h6 className="card-subtitle fw-medium mb-2">Horizontal cards are awesome!</h6>
                                                <p className="card-text">This is a wider card with supporting text below as a natural .</p>
                                            </div>
                                            <div className="card-footer">
                                                <p className="card-text"><small className="text-muted">Last updated 3 mins ago</small></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card custom-card">
                                    <div className="row g-0">
                                        <div className="col-md-8">
                                            <div className="card-header">
                                                <div className="card-title">Horizontal Cards</div>
                                            </div>
                                            <div className="card-body">
                                                <h6 className="card-subtitle fw-medium mb-2">Horizontal cards are awesome!</h6>
                                                <p className="card-text mb-3">This is a wider card with suppo    rting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                                <p className="card-text"><small className="text-muted">Last updated 3 mins ago</small></p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <img src="../assets/images/media/media-38.jpg" className="img-fluid rounded-end h-100 w-100" alt="..." />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card custom-card">
                                    <div className="row g-0">
                                        <div className="col-md-8">
                                            <div className="card-body">
                                                <h6 className="card-title fw-semibold mb-2">Horizontal Cards</h6>
                                                <div className="card-subtitle fw-medium mb-3">Horizontal cards are awesome!</div>
                                                <p className="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                            </div>
                                            <div className="card-footer">
                                                <p className="card-text"><small className="text-muted">Last updated 3 mins ago</small></p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <img src="../assets/images/media/media-39.jpg" className="img-fluid rounded-end h-100 w-100" alt="..." />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End::row-8 */}
                        {/* Start::row-9 */}
                        <h6 className="mb-3">Background Colored Cards:</h6>
                        <div className="row">
                            <div className="col-xl-3">
                                <div className="card custom-card card-bg-primary">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center w-100">
                                            <div className="me-2">
                                                <span className="avatar avatar-rounded">
                                                    <img src="../assets/images/faces/11.jpg" alt="img" />
                                                </span>
                                            </div>
                                            <div className>
                                                <div className="fs-15 fw-semibold">Adam Smith</div>
                                                <p className="mb-0 text-fixed-white op-7 fs-12">Finished by today</p>
                                            </div>
                                            <div className="ms-auto">
                                                <a href="javascript:void(0);" className="text-fixed-white"><i className="bi bi-three-dots-vertical" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card custom-card card-bg-secondary">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center w-100">
                                            <div className="me-2">
                                                <span className="avatar avatar-rounded">
                                                    <img src="../assets/images/faces/12.jpg" alt="img" />
                                                </span>
                                            </div>
                                            <div className>
                                                <div className="fs-15 fw-semibold">Elisha Corner</div>
                                                <p className="mb-0 text-fixed-white op-7 fs-12">Completed 24 days back</p>
                                            </div>
                                            <div className="ms-auto">
                                                <a href="javascript:void(0);" className="text-fixed-white"><i className="bi bi-three-dots-vertical" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card custom-card card-bg-warning">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center w-100">
                                            <div className="me-2">
                                                <span className="avatar avatar-rounded">
                                                    <img src="../assets/images/faces/1.jpg" alt="img" />
                                                </span>
                                            </div>
                                            <div className>
                                                <div className="fs-15 fw-semibold">Sarah Alina</div>
                                                <p className="mb-0 text-fixed-white op-7 fs-12">Completed today</p>
                                            </div>
                                            <div className="ms-auto">
                                                <a href="javascript:void(0);" className="text-fixed-white"><i className="bi bi-three-dots-vertical" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card custom-card card-bg-info">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center w-100">
                                            <div className="me-2">
                                                <span className="avatar avatar-rounded">
                                                    <img src="../assets/images/faces/8.jpg" alt="img" />
                                                </span>
                                            </div>
                                            <div className>
                                                <div className="fs-15 fw-semibold">Monica Karen</div>
                                                <p className="mb-0 text-fixed-white op-7 fs-12">Pending from 4 days</p>
                                            </div>
                                            <div className="ms-auto">
                                                <a href="javascript:void(0);" className="text-fixed-white"><i className="bi bi-three-dots-vertical" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card custom-card card-bg-success">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center w-100">
                                            <div className="me-2">
                                                <span className="avatar avatar-rounded">
                                                    <img src="../assets/images/faces/5.jpg" alt="img" />
                                                </span>
                                            </div>
                                            <div className>
                                                <div className="fs-15 fw-semibold">Samantha sid</div>
                                                <p className="mb-0 text-fixed-white op-7 fs-12">In leave for 1 month</p>
                                            </div>
                                            <div className="ms-auto">
                                                <a href="javascript:void(0);" className="text-fixed-white"><i className="bi bi-three-dots-vertical" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card custom-card card-bg-danger">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center w-100">
                                            <div className="me-2">
                                                <span className="avatar avatar-rounded">
                                                    <img src="../assets/images/faces/14.jpg" alt="img" />
                                                </span>
                                            </div>
                                            <div className>
                                                <div className="fs-15 fw-semibold">Sebastien steyn</div>
                                                <p className="mb-0 text-fixed-white op-7 fs-12">Completed by Tomorrow</p>
                                            </div>
                                            <div className="ms-auto">
                                                <a href="javascript:void(0);" className="text-fixed-white"><i className="bi bi-three-dots-vertical" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card custom-card card-bg-light">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center w-100">
                                            <div className="me-2">
                                                <span className="avatar avatar-rounded">
                                                    <img src="../assets/images/faces/13.jpg" alt="img" />
                                                </span>
                                            </div>
                                            <div className>
                                                <div className="fs-15 fw-semibold">Jacob Smith</div>
                                                <p className="mb-0 text-muted op-7 fs-12">Finished by 24,Nov</p>
                                            </div>
                                            <div className="ms-auto">
                                                <a href="javascript:void(0);" className="text-default"><i className="bi bi-three-dots-vertical" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card custom-card card-bg-dark">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center w-100">
                                            <div className="me-2">
                                                <span className="avatar avatar-rounded">
                                                    <img src="../assets/images/faces/16.jpg" alt="img" />
                                                </span>
                                            </div>
                                            <div className>
                                                <div className="fs-15 fw-semibold text-white">Pope Adam</div>
                                                <p className="mb-0 op-7 fs-12 text-white">Completed on 24,may</p>
                                            </div>
                                            <div className="ms-auto">
                                                <a href="javascript:void(0);" className="text-white"><i className="bi bi-three-dots-vertical" /></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End::row-9 */}
                        {/* Start::row-10 */}
                        <h6 className="mb-3">Colored Border Cards:</h6>
                        <div className="row">
                            <div className="col-xl-3">
                                <div className="card border border-primary custom-card">
                                    <div className="card-body">
                                        <p className="fs-14 fw-semibold mb-2 lh-1">Home Page Design
                                            <a href="javascript:void(0);"><i className="bi bi-plus-square float-end text-primary fs-18" /></a>
                                        </p>
                                        <div className="d-flex flex-wrap gap-2 mb-4">
                                            <span className="badge bg-primary-transparent">Framework</span>
                                            <span className="badge bg-secondary-transparent">Angular</span>
                                            <span className="badge bg-info-transparent">Php</span>
                                        </div>
                                        <div className="avatar-list-stacked">
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/2.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/8.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/2.jpg" alt="img" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card border border-secondary custom-card">
                                    <div className="card-body">
                                        <p className="fs-14 fw-semibold mb-2 lh-1">Landing Page Design
                                            <a href="javascript:void(0);"><i className="bi bi-plus-square float-end text-secondary fs-18" /></a>
                                        </p>
                                        <div className="d-flex flex-wrap gap-2 mb-4">
                                            <span className="badge bg-danger-transparent">Laravel</span>
                                            <span className="badge bg-teal-transparent">Codeignitor</span>
                                            <span className="badge bg-success-transparent">Php</span>
                                        </div>
                                        <div className="avatar-list-stacked">
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/4.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/6.jpg" alt="img" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card border border-warning custom-card">
                                    <div className="card-body">
                                        <p className="fs-14 fw-semibold mb-2 lh-1">Update New Project
                                            <a href="javascript:void(0);"><i className="bi bi-plus-square float-end text-warning fs-18" /></a>
                                        </p>
                                        <div className="d-flex flex-wrap gap-2 mb-4">
                                            <span className="badge bg-warning-transparent">Html</span>
                                            <span className="badge bg-secondary-transparent">Bootstrap</span>
                                            <span className="badge bg-info-transparent">React</span>
                                        </div>
                                        <div className="avatar-list-stacked">
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/1.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/12.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/10.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/16.jpg" alt="img" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card border border-info custom-card">
                                    <div className="card-body">
                                        <p className="fs-14 fw-semibold mb-2 lh-1">New Project Discussion
                                            <a href="javascript:void(0);"><i className="bi bi-plus-square float-end text-info fs-18" /></a>
                                        </p>
                                        <div className="d-flex flex-wrap gap-2 mb-4">
                                            <span className="badge bg-info-transparent">React</span>
                                            <span className="badge bg-primary-transparent">Typescript</span>
                                        </div>
                                        <div className="avatar-list-stacked">
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/3.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/14.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/11.jpg" alt="img" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card border border-danger custom-card">
                                    <div className="card-body">
                                        <p className="fs-14 fw-semibold mb-2 lh-1">Recent Projects Testing
                                            <a href="javascript:void(0);"><i className="bi bi-plus-square float-end text-danger fs-18" /></a>
                                        </p>
                                        <div className="d-flex flex-wrap gap-2 mb-4">
                                            <span className="badge bg-primary-transparent">Ui</span>
                                            <span className="badge bg-secondary-transparent">Angular</span>
                                            <span className="badge bg-info-transparent">Java</span>
                                        </div>
                                        <div className="avatar-list-stacked">
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/15.jpg" alt="img" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card border border-success custom-card">
                                    <div className="card-body">
                                        <p className="fs-14 fw-semibold mb-2 lh-1">About Us Page redesign
                                            <a href="javascript:void(0);"><i className="bi bi-plus-square float-end text-success fs-18" /></a>
                                        </p>
                                        <div className="d-flex flex-wrap gap-2 mb-4">
                                            <span className="badge bg-danger-transparent">Html</span>
                                            <span className="badge bg-warning-transparent">Symphony</span>
                                            <span className="badge bg-success-transparent">Php</span>
                                        </div>
                                        <div className="avatar-list-stacked">
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/6.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/9.jpg" alt="img" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card border border-light custom-card">
                                    <div className="card-body">
                                        <p className="fs-14 fw-semibold mb-2 lh-1">New Employees
                                            <a href="javascript:void(0);"><i className="bi bi-plus-square float-end text-default fs-18" /></a>
                                        </p>
                                        <div className="d-flex flex-wrap gap-2 mb-4">
                                            <span className="badge bg-warning-transparent">Html</span>
                                            <span className="badge bg-info-transparent">Cake Php</span>
                                            <span className="badge bg-success-transparent">React</span>
                                        </div>
                                        <div className="avatar-list-stacked">
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/5.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/6.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/7.jpg" alt="img" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3">
                                <div className="card border border-dark custom-card">
                                    <div className="card-body">
                                        <p className="fs-14 fw-semibold mb-2 lh-1">Terminated Employees
                                            <a href="javascript:void(0);"><i className="bi bi-plus-square float-end text-dark fs-18" /></a>
                                        </p>
                                        <div className="d-flex flex-wrap gap-2 mb-4">
                                            <span className="badge bg-primary-transparent">Angular</span>
                                        </div>
                                        <div className="avatar-list-stacked">
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/9.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/11.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/12.jpg" alt="img" />
                                            </span>
                                            <span className="avatar avatar-sm avatar-rounded">
                                                <img src="../assets/images/faces/15.jpg" alt="img" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End::row-10 */}
                        {/* Start::row-11 */}
                        <h6 className="mb-3">Card Groups With Footer:</h6>
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card-group">
                                    <div className="card custom-card">
                                        <img src="../assets/images/media/media-40.jpg" className="card-img-top" alt="..." />
                                        <div className="card-body">
                                            <h6 className="card-title fw-semibold">Delecious food is a blessing!</h6>
                                            <p className="card-text">This is a wider card with supporting text below as
                                                a
                                                natural lead-in to additional content. This content is a little bit
                                                longer.</p>
                                        </div>
                                        <div className="card-footer">
                                            <small className="text-muted">Last updated 3 mins ago</small>
                                        </div>
                                    </div>
                                    <div className="card custom-card">
                                        <img src="../assets/images/media/media-41.jpg" className="card-img-top" alt="..." />
                                        <div className="card-body">
                                            <h6 className="card-title fw-semibold">Is office the best place to earn knowledge?</h6>
                                            <p className="card-text">This card has supporting text below as a natural
                                                lead-in to additional content.</p>
                                        </div>
                                        <div className="card-footer">
                                            <small className="text-muted">Last updated 3 mins ago</small>
                                        </div>
                                    </div>
                                    <div className="card custom-card">
                                        <img src="../assets/images/media/media-42.jpg" className="card-img-top" alt="..." />
                                        <div className="card-body">
                                            <h6 className="card-title fw-semibold">Writing is an art.</h6>
                                            <p className="card-text">This is a wider card with supporting text below as
                                                a
                                                natural lead-in to additional content. This card has even longer
                                                content
                                                than the first to show that equal height action.</p>
                                        </div>
                                        <div className="card-footer">
                                            <small className="text-muted">Last updated 3 mins ago</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End::row-11 */}
                        {/* Start::row-12 */}
                        <h6 className="mb-3">Cards With Link:</h6>
                        <div className="row">
                            <div className="col-xxl-3 col-xl-12">
                                <div className="card custom-card">
                                    <a href="javascript:void(0);" className="card-anchor" />
                                    <img src="../assets/images/media/media-23.jpg" className="card-img-top" alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title fw-semibold mb-0 lh-1">Forests are Awesome.</h6>
                                        <span className="fs-13">Forests cover a significant area of the earth.</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-6 col-xl-6">
                                <div className="row">
                                    <div className="col-xxl-12 col-xl-12">
                                        <div className="card custom-card card-bg-primary">
                                            <a href="javascript:void(0);" className="card-anchor" />
                                            <div className="card-body">
                                                <blockquote className="blockquote mb-0 text-center">
                                                    <h6 className="text-fixed-white">The best and most beautiful things in the world cannot be seen or even touched — they must be felt with the heart..</h6>
                                                    <footer className="blockquote-footer mt-3 fs-14 text-fixed-white op-7">Someone famous as <cite title="Source Title">-Helen Keller</cite></footer>
                                                </blockquote>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-5 col-xl-12">
                                        <div className="card custom-card">
                                            <a href="javascript:void(0);" className="card-anchor" />
                                            <div className="card-body">
                                                <div className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <span className="avatar avatar-md">
                                                            <img src="../assets/images/faces/15.jpg" alt="img" />
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <p className="card-text mb-0 fs-14 fw-semibold">Atharva Simon.</p>
                                                        <div className="card-title text-muted fs-12 mb-0">Correspondent Professor</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card custom-card border border-info">
                                            <a href="javascript:void(0);" className="card-anchor" />
                                            <div className="card-body">
                                                <div className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <span className="avatar avatar-xl">
                                                            <img src="../assets/images/faces/8.jpg" alt="img" />
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <p className="card-text text-info mb-1 fs-14 fw-semibold">Alicia Keys.</p>
                                                        <div className="card-title fs-12 mb-1">Department Of Commerce</div>
                                                        <div className="card-title text-muted fs-11 mb-0">24 Years, Female</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-7 col-xl-12">
                                        <div className="card custom-card">
                                            <a href="javascript:void(0);" className="card-anchor" />
                                            <div className="row g-0">
                                                <div className="col-md-8">
                                                    <div className="card-body">
                                                        <h6 className="card-title mb-2 fw-semibold">Fox is Beautiful ?</h6>
                                                        <p className="card-text mb-0">This is a wild animal with supporting tactics and are very efficient at kill,they are very Dangerous.</p>
                                                        <p className="mb-0 card-text">
                                                            Fox lives mainly in forests and are well known for their hunting skills.
                                                        </p>
                                                    </div>
                                                    <div className="card-footer">
                                                        <p className="card-text"><small className="text-muted">Last updated 3 mins ago</small></p>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <img src="../assets/images/media/media-39.jpg" className="img-fluid rounded-end h-100" alt="..." />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-3 col-xl-6">
                                <div className="card custom-card">
                                    <a href="javascript:void(0);" className="card-anchor" />
                                    <img src="../assets/images/media/media-47.jpg" className="card-img-top" alt="..." />
                                    <div className="card-body">
                                        <h6 className="card-title fw-semibold">Most tropical areas are suitable</h6>
                                        <p className="card-text"> If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End::row-12 */}
                        {/* Start::row-13 */}
                        <h6 className="mb-3">Grid Cards:</h6>
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="row row-cols-1 row-cols-md-4 g-4">
                                    <div className="col">
                                        <div className="card custom-card">
                                            <img src="../assets/images/media/media-44.jpg" className="card-img-top" alt="..." />
                                            <div className="card-body">
                                                <h6 className="card-title fw-semibold">Morphology of Black Coffee.</h6>
                                                <p className="card-text"> If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="card custom-card">
                                            <img src="../assets/images/media/media-43.jpg" className="card-img-top" alt="..." />
                                            <div className="card-body">
                                                <h6 className="card-title fw-semibold">Research improves ability &amp; agility !</h6>
                                                <p className="card-text"> If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="card custom-card">
                                            <img src="../assets/images/media/media-45.jpg" className="card-img-top" alt="..." />
                                            <div className="card-body">
                                                <h6 className="card-title fw-semibold">Most tropical areas are suitable</h6>
                                                <p className="card-text"> If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="card custom-card">
                                            <img src="../assets/images/media/media-78.jpg" className="card-img-top" alt="..." />
                                            <div className="card-body">
                                                <h6 className="card-title fw-semibold">Are They seasonal fruits ?</h6>
                                                <p className="card-text"> If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End::row-13 */}
                    </div>
                </div>
                {/*APP-CONTENT CLOSE*/}

            </div>

            <Footer />
        </>
    )
}

export default DraggableCards